export const champTrees = {
  type: 'FeatureCollection',
  crs: { type: 'name', properties: { name: 'urn:ogc:def:crs:OGC:1.3:CRS84' } },
  features: [
    {
      type: 'Feature',
      properties: {
        species_x: 'YAUPON',
        subspecies: 'N/A',
        scientific_name: 'Ilex vomitoria',
        year_named: 2020.0,
        circumference_in: 12.0,
        height_in: 13.0,
        spread_ft: 9.0,
        total_points: 27.0,
        county: 'Sumter',
        year_remeasured: 2025,
        owner: 'Cory Sly',
        nominator: 'Cory Sly',
        sci_lc: 'ilex vomitoria',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/ilex_vomitoria/ilex_vomitoria.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Ilex vomitoria, commonly known as yaupon () or yaupon holly, is a species of holly that is native to southeastern North America. The word yaupon was derived from the Catawban yą́pą, from yą- tree + pą leaf.  Another common name, cassina, was borrowed from Timucua (despite this, it usually refers to Ilex cassine). The Latin name comes from an incorrect belief by Europeans that the plant caused vomiting in certain ceremonies.\nThe plant was traditionally used by Native Americans to make an infusion containing caffeine. It is only one of two known plants endemic to North America that produce caffeine. The other is Ilex cassine, commonly known as dahoon holly.  Yaupon is also widely used for landscaping in its native range.\n\n',
        Longitude: -88.200057,
        Latitude: 32.597481,
      },
      geometry: { type: 'Point', coordinates: [-88.200057, 32.597481] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'YELLOW-POPLAR',
        subspecies: 'N/A',
        scientific_name: 'Liriodendron tulipifera',
        year_named: 1974.0,
        circumference_in: 252.0,
        height_in: 153.0,
        spread_ft: 73.0,
        total_points: 423.0,
        county: 'Lawrence',
        year_remeasured: 2016,
        owner: 'U. S. Forest Service',
        nominator: 'W. E. Bustin',
        sci_lc: 'liriodendron tulipifera',
        file_id: 60245.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/liriodendron_tulipifera/pi0068-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/liriodendron_tulipifera/pi0068-01-1.png',
        species_y: 'Liriodendron tulipifera',
        source: 'lab',
        wiki_summary:
          'Liriodendron tulipifera—known as the tulip tree, American tulip tree, tulipwood, tuliptree, tulip poplar, whitewood, fiddletree, and yellow-poplar—is the North American representative of the two-species genus Liriodendron (the other member is Liriodendron chinense), and the tallest eastern hardwood. It is native to eastern North America from Southern Ontario and possibly southern Quebec to Illinois eastward to southwestern Massachusetts and Rhode Island, and south to central Florida and Louisiana. It can grow to more than 50 m (160 ft) in virgin cove forests of the Appalachian Mountains, often with no limbs until it reaches 25–30 m (80–100 ft) in height, making it a very valuable timber tree.\nIt is fast-growing, without the common problems of weak wood strength and short lifespan often seen in fast-growing species. April marks the start of the flowering period in the Southern United States (except as noted below); trees at the northern limit of cultivation begin to flower in June. The flowers are pale green or yellow (rarely white), with an orange band on the tepals; they yield large quantities of nectar. The tulip tree is the state tree of Indiana, Kentucky, and Tennessee.\n\n',
        Longitude: -87.321865,
        Latitude: 34.529776,
      },
      geometry: { type: 'Point', coordinates: [-87.321865, 34.529776] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'YELLOWWOOD',
        subspecies: 'N/A',
        scientific_name: 'Cladrastis kentukea',
        year_named: 2014.0,
        circumference_in: 62.0,
        height_in: 80.0,
        spread_ft: 59.0,
        total_points: 157.0,
        county: 'Monroe',
        year_remeasured: 2019,
        owner: 'U.S. Army Corps of Engineers',
        nominator: 'Wayne Webb',
        sci_lc: 'cladrastis kentukea',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/cladrastis_kentukea/cladrastis_kentukea.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Cladrastis kentukea, the Kentucky yellowwood or American yellowwood (syn. C. lutea, C. tinctoria), is a species of Cladrastis native to the Southeastern United States, with a restricted range from western North Carolina west to eastern Oklahoma, and from southern Missouri and Indiana south to central Alabama. Also the tree is sometimes called Virgilia.',
        Longitude: -87.383266,
        Latitude: 31.580332,
      },
      geometry: { type: 'Point', coordinates: [-87.383266, 31.580332] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'PLUM',
        subspecies: ' Flatwoods',
        scientific_name: 'Prunus umbellata',
        year_named: 2010.0,
        circumference_in: 20.0,
        height_in: 24.0,
        spread_ft: 18.0,
        total_points: 49.0,
        county: 'Baldwin',
        year_remeasured: 2021,
        owner: 'Baldwin County',
        nominator: 'Dr. Harry Larsen & Fred Nation',
        sci_lc: 'prunus umbellata',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/prunus_umbellata/prunus_umbellata.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Prunus umbellata, called flatwoods plum, hog plum and sloe plum, is a plum species native to the United States from Virginia, south to Florida, and west to Texas.Prunus umbellata can reach 20 ft (6.1 m) in height with a 15 ft (4.6 m) spread. It has alternate serrate green leaves that turn yellow in autumn. Flowers are white, creamy, or grayish. Fruits are round, purple, and 0.5–1 in (1.3–2.5 cm) in diameter. P. umbellata trees can live up to 40 years and are very difficult to distinguish from Prunus angustifolia, with which it hybridizes easily. The trees bloom and bear fruit later than other plums. The fruits mature August–October. Large crops appear only every 3-4 years. The fruits are made into jellies and jams.',
        Longitude: -87.746067,
        Latitude: 30.659218,
      },
      geometry: { type: 'Point', coordinates: [-87.746067, 30.659218] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'PONDCYPRESS',
        subspecies: 'N/A',
        scientific_name: 'Taxodium ascendens',
        year_named: 2013.0,
        circumference_in: 131.0,
        height_in: 92.0,
        spread_ft: 32.0,
        total_points: 231.0,
        county: 'Mobile',
        year_remeasured: 2018,
        owner: 'Alabama State Port Authority',
        nominator: 'Gena Todia & Fred Nation',
        sci_lc: 'taxodium ascendens',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/taxodium_ascendens/taxodium_ascendens.png?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Taxodium ascendens, also known as pond cypress, is a deciduous conifer of the genus Taxodium, native to North America. Many botanists treat it as a variety of bald cypress, Taxodium distichum (as T. distichum var. imbricatum) rather than as a distinct species, but it differs in ecology, occurring mainly in still blackwater rivers, ponds and swamps without silt-rich flood deposits. It predominates in cypress dome habitats.',
        Longitude: -88.196568,
        Latitude: 30.684573,
      },
      geometry: { type: 'Point', coordinates: [-88.196568, 30.684573] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'PRIVET',
        subspecies: ' Eastern Swamp',
        scientific_name: 'Forestiera acuminata',
        year_named: 1995.0,
        circumference_in: 19.0,
        height_in: 36.0,
        spread_ft: 24.0,
        total_points: 61.0,
        county: 'Madison',
        year_remeasured: 2017,
        owner: 'U.S. Army & TVA',
        nominator: 'Susan Weber',
        sci_lc: 'forestiera acuminata',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/forestiera_acuminata/forestiera_acuminata.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Forestiera acuminata, commonly known as eastern swamp privet, is a deciduous shrub or small tree that is native to the southeastern and central United States, growing primarily in or near wetlands. It is especially common along the Mississippi Valley as far north as Illinois and Indiana, but found also across the South from eastern Texas to South Carolina.The species withstands flooding and its fruit is consumed by wild ducks.',
        Longitude: -86.55108,
        Latitude: 34.764238,
      },
      geometry: { type: 'Point', coordinates: [-86.55108, 34.764238] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'REDBUD',
        subspecies: ' Eastern',
        scientific_name: 'Cercis canadensis',
        year_named: 2000.0,
        circumference_in: 86.0,
        height_in: 36.0,
        spread_ft: 34.0,
        total_points: 131.0,
        county: 'Limestone',
        year_remeasured: 2017,
        owner: 'Walter Hardiman',
        nominator: 'Doug Ezzell',
        sci_lc: 'cercis canadensis',
        file_id: 58737.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/cercis_canadensis/pi0001-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/cercis_canadensis/pi0001-01-1.png',
        species_y: 'Cercis canadensis',
        source: 'lab',
        wiki_summary:
          'Cercis canadensis, the eastern redbud, is a large deciduous shrub or small tree, native to eastern North America from southern Michigan south to central Mexico, east to New Jersey. Species thrive as far west as California and as far north as southern Ontario, roughly corresponding to USDA hardiness zone 6b. It is the state tree of Oklahoma.\n\n',
        Longitude: -86.9814,
        Latitude: 34.810239,
      },
      geometry: { type: 'Point', coordinates: [-86.9814, 34.810239] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'REDCEDAR',
        subspecies: ' Eastern',
        scientific_name: 'Juniperus virginiana',
        year_named: 1979.0,
        circumference_in: 179.0,
        height_in: 52.0,
        spread_ft: 27.0,
        total_points: 238.0,
        county: 'Wilcox',
        year_remeasured: 2017,
        owner: 'Lou & John Harmon',
        nominator: 'William C. Carrigan',
        sci_lc: 'juniperus virginiana',
        file_id: 58838.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/juniperus_virginiana/pi1016-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/juniperus_virginiana/pi1016-01-1.png',
        species_y: 'Juniperus virginiana',
        source: 'lab',
        wiki_summary:
          'Juniperus virginiana, known as red cedar, eastern redcedar, Virginian juniper, eastern juniper, red juniper, pencil cedar, and aromatic cedar, is a species of juniper native to eastern North America from southeastern Canada to the Gulf of Mexico and east of the Great Plains. Further west it is replaced by the related Juniperus scopulorum (Rocky Mountain juniper) and to the southwest by Juniperus ashei (Ashe juniper).',
        Longitude: -87.302205,
        Latitude: 31.99033,
      },
      geometry: { type: 'Point', coordinates: [-87.302205, 31.99033] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'REDCEDAR',
        subspecies: ' Southern',
        scientific_name: 'Juniperus silicicola',
        year_named: 2001.0,
        circumference_in: 174.0,
        height_in: 56.0,
        spread_ft: 68.0,
        total_points: 247.0,
        county: 'Baldwin',
        year_remeasured: 2017,
        owner: 'Mr. & Mrs. John Ledbetter',
        nominator: 'Ken Richardson & Tom Ellis',
        sci_lc: 'juniperus silicicola',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/juniperus_silicicola/juniperus_silicicola.JPG?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Juniperus virginiana, known as red cedar, eastern redcedar, Virginian juniper, eastern juniper, red juniper, pencil cedar, and aromatic cedar, is a species of juniper native to eastern North America from southeastern Canada to the Gulf of Mexico and east of the Great Plains. Further west it is replaced by the related Juniperus scopulorum (Rocky Mountain juniper) and to the southwest by Juniperus ashei (Ashe juniper).',
        Longitude: -87.746067,
        Latitude: 30.659218,
      },
      geometry: { type: 'Point', coordinates: [-87.746067, 30.659218] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'SASSAFRAS',
        subspecies: 'N/A',
        scientific_name: 'Sassafras albidum',
        year_named: 2020.0,
        circumference_in: 162.0,
        height_in: 47.0,
        spread_ft: 57.0,
        total_points: 223.0,
        county: 'Madison',
        year_remeasured: 2025,
        owner: 'City of Huntsville',
        nominator: 'Marc Byers',
        sci_lc: 'sassafras albidum',
        file_id: 4593.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/field/sassafras_albidum/1249061039_0000.jpg?raw=true',
        segmented_path:
          'dataset/segmented/field/sassafras_albidum/1249061039_0000.png',
        species_y: 'Sassafras albidum',
        source: 'field',
        wiki_summary:
          'Sassafras albidum (sassafras, white sassafras, red sassafras, or silky sassafras) is a species of Sassafras native to eastern North America, from southern Maine and southern Ontario west to Iowa, and south to central Florida and eastern Texas. It occurs throughout the eastern deciduous forest habitat type, at altitudes of up to 1,500 m (5000 feet) above sea level. It formerly also occurred in southern Wisconsin, but is extirpated there as a native tree.',
        Longitude: -86.55108,
        Latitude: 34.764238,
      },
      geometry: { type: 'Point', coordinates: [-86.55108, 34.764238] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'SASSAFRAS',
        subspecies: 'N/A',
        scientific_name: 'Sassafras albidum',
        year_named: 1992.0,
        circumference_in: 140.0,
        height_in: 74.0,
        spread_ft: 33.0,
        total_points: 222.0,
        county: 'Dallas',
        year_remeasured: 2017,
        owner: 'Sarah Petty Dagenhart',
        nominator: 'Larry Brooks & Jason Shelton',
        sci_lc: 'sassafras albidum',
        file_id: 4593.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/field/sassafras_albidum/1249061039_0000.jpg?raw=true',
        segmented_path:
          'dataset/segmented/field/sassafras_albidum/1249061039_0000.png',
        species_y: 'Sassafras albidum',
        source: 'field',
        wiki_summary:
          'Sassafras albidum (sassafras, white sassafras, red sassafras, or silky sassafras) is a species of Sassafras native to eastern North America, from southern Maine and southern Ontario west to Iowa, and south to central Florida and eastern Texas. It occurs throughout the eastern deciduous forest habitat type, at altitudes of up to 1,500 m (5000 feet) above sea level. It formerly also occurred in southern Wisconsin, but is extirpated there as a native tree.',
        Longitude: -87.114356,
        Latitude: 32.33354,
      },
      geometry: { type: 'Point', coordinates: [-87.114356, 32.33354] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'SILVERBELL',
        subspecies: ' Carolina',
        scientific_name: 'Halesia carolina',
        year_named: 2011.0,
        circumference_in: 44.0,
        height_in: 60.0,
        spread_ft: 40.0,
        total_points: 114.0,
        county: 'Randolph',
        year_remeasured: 2021,
        owner: 'Cynthia Burns Rothstein',
        nominator: 'Charles Wise & Ryan Prince',
        sci_lc: 'halesia carolina',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/halesia_carolina/halesia_carolina.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Halesia carolina, commonly called Carolina silverbell or little silverbell, is a species of flowering plant in the family Styracaceae, native to the southeastern United States.',
        Longitude: -85.464068,
        Latitude: 33.296475,
      },
      geometry: { type: 'Point', coordinates: [-85.464068, 33.296475] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'SILVERBELL',
        subspecies: ' Two-winged',
        scientific_name: 'Halesia diptera',
        year_named: 1998.0,
        circumference_in: 42.0,
        height_in: 72.0,
        spread_ft: 27.0,
        total_points: 121.0,
        county: 'Wilcox',
        year_remeasured: 2017,
        owner: 'Tommy & Jeanell Lawler',
        nominator: 'Tommy Lawler',
        sci_lc: 'halesia diptera',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/halesia_diptera/halesia_diptera.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Halesia diptera, the two-wing silverbell or two-winged snowdrop tree, is a species in the family Styracaceae, native to the southeastern United States from South Carolina and Florida west to eastern Texas. It is cultivated as an ornamental tree.',
        Longitude: -87.302205,
        Latitude: 31.99033,
      },
      geometry: { type: 'Point', coordinates: [-87.302205, 31.99033] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'SOURWOOD',
        subspecies: 'N/A',
        scientific_name: 'Oxydendrum arboreum',
        year_named: 2009.0,
        circumference_in: 68.0,
        height_in: 89.0,
        spread_ft: 42.0,
        total_points: 168.0,
        county: 'Marion',
        year_remeasured: 2019,
        owner: 'James Ross Markham',
        nominator: 'Josh Angel & Tony Avery',
        sci_lc: 'oxydendrum arboreum',
        file_id: 60690.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/oxydendrum_arboreum/wb1106-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/oxydendrum_arboreum/wb1106-01-1.png',
        species_y: 'Oxydendrum arboreum',
        source: 'lab',
        wiki_summary:
          'Oxydendrum arboreum,  the sourwood or sorrel tree, is the sole species in the genus Oxydendrum, in the family Ericaceae. It is native to eastern North America, from southern Pennsylvania south to northwest Florida and west to southern Illinois; it is most common in the lower chain of the Appalachian Mountains. The tree is frequently seen as a component of oak-heath forests.\n\n',
        Longitude: -87.881551,
        Latitude: 34.138219,
      },
      geometry: { type: 'Point', coordinates: [-87.881551, 34.138219] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'SPARKLEBERRY',
        subspecies: 'N/A',
        scientific_name: 'Vaccinium arboreum',
        year_named: 2020.0,
        circumference_in: 66.0,
        height_in: 25.0,
        spread_ft: 44.0,
        total_points: 101.0,
        county: 'Choctaw',
        year_remeasured: 2025,
        owner: 'Earl Jenkins',
        nominator: 'Earl Jenkins',
        sci_lc: 'vaccinium arboreum',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/vaccinium_arboreum/vaccinium_arboreum.png?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Vaccinium arboreum (sparkleberry or farkleberry) is a species of Vaccinium native to the southeastern and south-central United States, from southern Virginia west to southeastern Nebraska, south to Florida and eastern Texas, and north to Illinois.',
        Longitude: -88.248887,
        Latitude: 31.991008,
      },
      geometry: { type: 'Point', coordinates: [-88.248887, 31.991008] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'SUGARBERRY',
        subspecies: 'N/A',
        scientific_name: 'Celtis laevigata',
        year_named: 1994.0,
        circumference_in: 221.0,
        height_in: 82.0,
        spread_ft: 82.0,
        total_points: 324.0,
        county: 'Barbour',
        year_remeasured: 2017,
        owner: 'Eufaula National Wildlife Refuge',
        nominator: 'Daniel J. Drennen',
        sci_lc: 'celtis laevigata',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/celtis_laevigata/celtis_laevigata.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          "Celtis laevigata is a medium-sized tree native to North America.  Common names include sugarberry, Southern hackberry, or in the southern U.S. sugar hackberry or just hackberry.\nSugarberry is easily confused with common hackberry (C. occidentalis) where the range overlaps.  Sugarberry has narrower leaves which are smoother above.  The species can also be distinguished by habitat: where the ranges overlap, common hackberry occurs primarily in upland areas, whereas sugarberry occurs mainly in bottomland areas.\nSugarberry's range extends from the Eastern United States west to Texas and south to northeastern Mexico. It is also found on the island of Bermuda.\n\n",
        Longitude: -85.405456,
        Latitude: 31.87067,
      },
      geometry: { type: 'Point', coordinates: [-85.405456, 31.87067] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'SUMAC',
        subspecies: ' Smooth',
        scientific_name: 'Rhus glabra',
        year_named: 2011.0,
        circumference_in: 12.0,
        height_in: 21.0,
        spread_ft: 11.0,
        total_points: 36.0,
        county: 'Jackson',
        year_remeasured: 2016,
        owner: 'The Nature Conservancy',
        nominator: 'Jason Shelton',
        sci_lc: 'rhus glabra',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/rhus_glabra/rhus_glabra.png?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Rhus glabra, the smooth sumac, (also known as white sumac, upland sumac, or scarlet sumac) is a species of sumac in the family Anacardiaceae, native to North America, from southern Quebec west to southern British Columbia in Canada, and south to northern Florida and Arizona in the United States and Tamaulipas in northeastern Mexico.\nOne of the easiest shrubs to identify throughout the year (unless mistaken for poison sumac, in the absence of mature fruit), smooth sumac has a spreading, open-growing shrub growing up to 3 m (9.8 ft) tall, rarely to 5 m (16 ft). The leaves are alternate, 30–50 cm (12–20 in) long, compound with 11–31 oppositely paired leaflets, each leaflet 5–11 cm (2–4 1⁄4 in) long, with a serrated margin. The leaves turn scarlet in the fall. The flowers are tiny, green, produced in dense erect panicles 10–25 cm (4–10 in) tall, in the spring, later followed by large panicles of edible crimson berries that remain throughout the winter. The buds are small, covered with brown hair and borne on fat, hairless twigs. The bark on older wood is smooth and grey to brown.\n\nIn late summer it sometimes forms galls on the underside of leaves, caused by the parasitic sumac leaf gall aphid, Melaphis rhois. The galls are not harmful to the tree.',
        Longitude: -85.9774,
        Latitude: 34.763522,
      },
      geometry: { type: 'Point', coordinates: [-85.9774, 34.763522] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'SUMAC',
        subspecies: ' Winged',
        scientific_name: 'Rhus copallina',
        year_named: 2016.0,
        circumference_in: 19.0,
        height_in: 47.0,
        spread_ft: 20.0,
        total_points: 71.0,
        county: 'Cleburne',
        year_remeasured: 2018,
        owner: 'Adam Dasinger',
        nominator: 'Adam Dasinger',
        sci_lc: 'rhus copallina',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/rhus_copallina/rhus_copallina.png?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Rhus copallinum  (Rhus copallina is also used but, this is not consistent with the rules of the  International Association for Plant Taxonomy), the winged sumac, shining sumac, dwarf sumac or flameleaf sumac, is a species of flowering plant in the cashew family (Anacardiaceae) that is native to eastern North America. It is a deciduous tree growing to 3.5–5.5 metres (11–18 ft) tall and an equal spread with a rounded crown.  A 5-year-old sapling will stand about 2.5 metres (8.2 ft).',
        Longitude: -85.516109,
        Latitude: 33.671981,
      },
      geometry: { type: 'Point', coordinates: [-85.516109, 33.671981] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'SWEETGUM',
        subspecies: 'N/A',
        scientific_name: 'Liquidambar styraciflua',
        year_named: 2015.0,
        circumference_in: 163.0,
        height_in: 117.0,
        spread_ft: 108.0,
        total_points: 307.0,
        county: 'Marengo',
        year_remeasured: 2020,
        owner: 'U.S. Army Corps of Engineers',
        nominator: 'Ben Sherrod',
        sci_lc: 'liquidambar styraciflua',
        file_id: 59776.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/liquidambar_styraciflua/wb1094-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/liquidambar_styraciflua/wb1094-01-1.png',
        species_y: 'Liquidambar styraciflua',
        source: 'lab',
        wiki_summary:
          'American sweetgum (Liquidambar styraciflua), also known as American storax, hazel pine, bilsted, redgum, satin-walnut, star-leaved gum, alligatorwood, or simply sweetgum, is a deciduous tree in the genus Liquidambar native to warm temperate areas of eastern North America and tropical montane regions of Mexico and Central America. Sweet gum is one of the main valuable forest trees in the southeastern United States, and is a popular ornamental tree in temperate climates. It is recognizable by the combination of its five-pointed star-shaped leaves (similar to maple leaves) and its hard, spiked fruits. It is currently classified in the plant family Altingiaceae, but was formerly considered a member of the Hamamelidaceae.\n\n',
        Longitude: -87.791091,
        Latitude: 32.247591,
      },
      geometry: { type: 'Point', coordinates: [-87.791091, 32.247591] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'SWEETLEAF',
        subspecies: 'N/A',
        scientific_name: 'Symplocos tinctoria',
        year_named: 2009.0,
        circumference_in: 25.0,
        height_in: 73.0,
        spread_ft: 17.0,
        total_points: 102.0,
        county: 'Marion',
        year_remeasured: 2019,
        owner: 'Marshal W. & Jimmy D. Rea; Cherry Gregg O',
        nominator: 'Tony Avery',
        sci_lc: 'symplocos tinctoria',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/symplocos_tinctoria/symplocos_tinctoria.png?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          "Symplocos tinctoria (the common sweetleaf, horse-sugar, or yellowwood) is a deciduous or evergreen shrub or tree. It is recognized by pith of twigs chambered; by foliage not notably aromatic when bruised, leaves finely hairy beneath. Shrubs or trees to 17 m tall by 36 cm DBH. The largest first-year twigs are under 3 mm across, terminal buds with acute tip, scales ciliate. Leaves are 7–15 cm long, margin entire or occasionally some teeth on the apical half, with a sweet taste that may be faint in old leaves. It is conspicuous when in flower; flowers opening before new leaves develop, fragrant, in clusters from axils of previous year's leaves or from just above the leaf scars if the leaves have fallen; the petals are creamy yellow to yellow, with one pistil. Fruits nearly cylindrical to ellipsoid drupes 8–12 mm long, with thin pulp and a hard stone containing 1 seed; the tip usually retaining parts of the sepals. Foliage is relished by browsing wildlife. A yellow dye may be obtained from bark and leaves. It flowers Mar to May.",
        Longitude: -87.881551,
        Latitude: 34.138219,
      },
      geometry: { type: 'Point', coordinates: [-87.881551, 34.138219] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'SYCAMORE',
        subspecies: 'N/A',
        scientific_name: 'Platanus occidentalis',
        year_named: 2010.0,
        circumference_in: 188.0,
        height_in: 120.0,
        spread_ft: 98.0,
        total_points: 333.0,
        county: 'Montgomery',
        year_remeasured: 2021,
        owner: 'Thomas Upchurch',
        nominator: 'Russell Stringer',
        sci_lc: 'platanus occidentalis',
        file_id: 4309.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/field/platanus_occidentalis/1248105841_0000.jpg?raw=true',
        segmented_path:
          'dataset/segmented/field/platanus_occidentalis/1248105841_0000.png',
        species_y: 'Platanus occidentalis',
        source: 'field',
        wiki_summary:
          'Platanus occidentalis, also known as American sycamore, American planetree, western plane, occidental plane, buttonwood, and water beech, is a species of Platanus native to the eastern and central United States, the mountains of northeastern Mexico, extreme southern Ontario, and possibly extreme southern Quebec. It is usually called sycamore in North America, a name which can refer to other types of tree in other parts of the world.\nThe species epithet occidentalis is Latin for "western", referring to the Western Hemisphere, because at the time when it was named by Carl Linnaeus, the only other species in the genus was P. orientalis ("eastern"), native to the Eastern Hemisphere.\n\n',
        Longitude: -86.203831,
        Latitude: 32.203651,
      },
      geometry: { type: 'Point', coordinates: [-86.203831, 32.203651] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'TUPELO',
        subspecies: ' Swamp',
        scientific_name: 'Nyssa biflora',
        year_named: 2016.0,
        circumference_in: 125.0,
        height_in: 88.0,
        spread_ft: 75.0,
        total_points: 232.0,
        county: 'Baldwin',
        year_remeasured: 2021,
        owner: 'City of Fairhope',
        nominator: 'Fred Nation- N',
        sci_lc: 'nyssa biflora',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/nyssa_biflora/nyssa_biflora.png?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Nyssa biflora, commonly referred to as the swamp tupelo, or swamp black-gum is a species of tupelo that lives in wetland habitats. Swamp tupelo grows chiefly in the coastal plains from Delaware, eastern Maryland, and southeastern Virginia, south to southern Florida and west to eastern Texas. Its range extends north up the Mississippi Valley to southern Arkansas and west and south Tennessee.The swamp tupelo grows in humid warm climates. It not only tolerates flooding but actually thrives under those conditions. It is seldom found on sites that are not inundated much of the growing season. Swamp tupelo grows in headwater swamps, strands, ponds, river bottoms, bays, estuaries, and low coves. Normally it does not grow in the deeper parts of swamps or overflow river bottoms.The type of water regime is more important to growth of swamp tupelo than the soil type. Best growth is achieved on sites where the soil is continuously saturated with very shallow moving water. Growth can be reduced as much as 50 percent when the water is stagnant, as in ponds. Intermittent flooding, with periodic drying cycles, or continuous deep flooding even by moving water, also reduces growth.Trees and shrubs commonly associated with swamp tupelo are red maple (Acer rubrum), buttonbush (Cephalanthus occidentalis), buckwheat-tree (Cliftonia monophylla), dogwood (Cornus spp.), swamp cyrilla (Cyrilla racemiflora), swamp-privet (Forestiera acuminata), Carolina ash (Fraxinus caroliniana), loblolly-bay (Gordonia lasianthus), dahoon (Ilex cassine), inkberry (I. glabra), yaupon (I. vomitoria), fetterbush lyonia (Lyonia lucida), and bayberry (Myrica spp.).The swamp tupelo has minute greenish-white flowers that appear in the spring with the leaves, usually in late April. Insects, primarily bees, are the major pollinating vector, but pollen is also spread by wind. The fruit, a drupe, changes from green to a dark blue as it ripens, usually in early November. The seeds normally overwinter and germinate the following spring. Germination does not take place under water, but submerged seeds germinate once the water subsides below the soil surface. Germination is rapid in moist, drained conditions at 21 °C (70 °F) and higher. After germination, seedlings must grow rapidly to keep the apex and leaves above water, because prolonged submergence during active growth will kill them. Submergence during the dormant season, however, has no adverse effect.Swamp tupelo normally develops a taproot and has a swollen base to the mean height of the growing season water level. Water roots, which develop under flooded conditions, help support the tree and capture nutrients. These specialized roots tolerate high carbon dioxide concentrations, oxidize the rhizosphere, and carry on anaerobic respiration. Thus, they are the key to the species ability to thrive under flooded conditions.',
        Longitude: -87.746067,
        Latitude: 30.659218,
      },
      geometry: { type: 'Point', coordinates: [-87.746067, 30.659218] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'TUPELO',
        subspecies: ' Water',
        scientific_name: 'Nyssa aquatica',
        year_named: 2007.0,
        circumference_in: 237.0,
        height_in: 112.0,
        spread_ft: 88.0,
        total_points: 371.0,
        county: 'Madison',
        year_remeasured: 2017,
        owner: 'City of Huntsville',
        nominator: 'Susan Weber',
        sci_lc: 'nyssa aquatica',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/nyssa_aquatica/nyssa_aquatica.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Nyssa aquatica, commonly called the water tupelo, cottongum, wild olive, large tupelo, tupelo-gum, or water-gum, is a large, long-lived tree in the tupelo genus (Nyssa) that grows in swamps and floodplains in the Southeastern United States.Nyssa aquatica trunks have a swollen base that tapers up to a long, clear bole, and its root system is periodically under water. Water tupelo trees often occurs in pure stands.',
        Longitude: -86.55108,
        Latitude: 34.764238,
      },
      geometry: { type: 'Point', coordinates: [-86.55108, 34.764238] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'WALNUT',
        subspecies: ' Black',
        scientific_name: 'Juglans nigra',
        year_named: 1973.0,
        circumference_in: 199.0,
        height_in: 76.0,
        spread_ft: 97.0,
        total_points: 299.0,
        county: 'Colbert',
        year_remeasured: 2017,
        owner: 'City of Sheffield',
        nominator: 'B. F. Walden',
        sci_lc: 'juglans nigra',
        file_id: 4543.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/field/juglans_nigra/1249060272_0000.jpg?raw=true',
        segmented_path:
          'dataset/segmented/field/juglans_nigra/1249060272_0000.png',
        species_y: 'Juglans nigra',
        source: 'field',
        wiki_summary:
          'Juglans nigra, the eastern American black walnut, is a species of deciduous tree in the walnut family, Juglandaceae, native to North America. It grows mostly in riparian zones, from southern Ontario, west to southeast South Dakota, south to Georgia, northern Florida and southwest to central Texas. Wild trees in the upper Ottawa Valley may be an isolated native population or may have derived from planted trees.\nBlack walnut is an important tree commercially, as the wood is a deep brown color and easily worked. Walnut seeds (nuts) are cultivated for their distinctive and desirable taste. Walnut trees are grown both for lumber and food, and many cultivars have been developed for improved quality wood or nuts. Black walnut is susceptible to thousand cankers disease that provoked a decline of walnut trees in some regions.\nBlack walnut is known for being allelopathic, which means that it releases chemicals from its roots and other tissues that harm other organisms and give the tree a competitive advantage.',
        Longitude: -87.801457,
        Latitude: 34.703112,
      },
      geometry: { type: 'Point', coordinates: [-87.801457, 34.703112] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'WITCH-HAZEL',
        subspecies: 'N/A',
        scientific_name: 'Hamamelis virginiana',
        year_named: 2012.0,
        circumference_in: 13.0,
        height_in: 32.0,
        spread_ft: 21.0,
        total_points: 50.0,
        county: 'Randolph',
        year_remeasured: 2017,
        owner: 'Stan Roark',
        nominator: 'Stan Roark',
        sci_lc: 'hamamelis virginiana',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/hamamelis_virginiana/hamamelis_virginiana.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Hamamelis virginiana, known as witch-hazel, common witch-hazel, and American witch-hazel, is a species of flowering shrub native to eastern North America, from Nova Scotia west to Minnesota, and south to central Florida to eastern Texas.',
        Longitude: -85.464068,
        Latitude: 33.296475,
      },
      geometry: { type: 'Point', coordinates: [-85.464068, 33.296475] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Water',
        scientific_name: 'Quercus nigra',
        year_named: 2012.0,
        circumference_in: 256.0,
        height_in: 96.0,
        spread_ft: 136.0,
        total_points: 386.0,
        county: 'Montgomery',
        year_remeasured: 2017,
        owner: 'Kirk McKeen',
        nominator: 'Katie McKeen',
        sci_lc: 'quercus nigra',
        file_id: 71805.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/quercus_nigra/wb1223-01-1.jpg?raw=true',
        segmented_path: 'dataset/segmented/lab/quercus_nigra/wb1223-01-1.png',
        species_y: 'Quercus nigra',
        source: 'lab',
        wiki_summary:
          'Quercus nigra, the water oak, is an oak in the red oak group (Quercus sect. Lobatae), native to the eastern and south-central United States, found in all the coastal states from New Jersey to Texas, and inland as far as Oklahoma, Kentucky, and southern Missouri. It occurs in lowlands and up to 450 m (1500 ft) altitude.',
        Longitude: -86.203831,
        Latitude: 32.203651,
      },
      geometry: { type: 'Point', coordinates: [-86.203831, 32.203651] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' White',
        scientific_name: 'Quercus alba',
        year_named: 2013.0,
        circumference_in: 267.0,
        height_in: 102.0,
        spread_ft: 119.0,
        total_points: 399.0,
        county: 'Colbert',
        year_remeasured: 2018,
        owner: 'Jeff Mitchell',
        nominator: 'Darryl Rutland',
        sci_lc: 'quercus alba',
        file_id: 4833.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/field/quercus_alba/1249580462_0000.jpg?raw=true',
        segmented_path:
          'dataset/segmented/field/quercus_alba/1249580462_0000.png',
        species_y: 'Quercus alba',
        source: 'field',
        wiki_summary:
          'Quercus alba, the white oak, is one of the preeminent hardwoods of eastern and central North America. It is a long-lived oak, native to eastern and central North America and found from Minnesota, Ontario, Quebec, and southern Maine south as far as northern Florida and eastern Texas. Specimens have been documented to be over 450 years old.Although called a white oak, it is very unusual to find an individual specimen with white bark; the usual colour is a light grey. The name comes from the colour of the finished wood. In the forest it can reach a magnificent height and in the open it develops into a massive broad-topped tree with large branches striking out at wide angles.',
        Longitude: -87.801457,
        Latitude: 34.703112,
      },
      geometry: { type: 'Point', coordinates: [-87.801457, 34.703112] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Willow',
        scientific_name: 'Quercus phellos',
        year_named: 2012.0,
        circumference_in: 248.0,
        height_in: 84.0,
        spread_ft: 99.0,
        total_points: 357.0,
        county: 'Shelby',
        year_remeasured: 2017,
        owner: 'David R. Shaw',
        nominator: 'David R. Shaw',
        sci_lc: 'quercus phellos',
        file_id: 4838.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/field/quercus_phellos/1249580491_0000.jpg?raw=true',
        segmented_path:
          'dataset/segmented/field/quercus_phellos/1249580491_0000.png',
        species_y: 'Quercus phellos',
        source: 'field',
        wiki_summary:
          "Quercus phellos, the willow oak, is a North American species of a deciduous tree in the red oak group of oaks. It is native to the eastern and central United States from Long Island Sound south to northern Florida, and west to southernmost Illinois, Missouri, Oklahoma, and eastern Texas. It is most commonly found growing on lowland floodplains, often along streams, but rarely also in uplands with poor drainage, up to 400 meters (1,300 ft) altitude. Willow oak's natural range extends into southeastern Pennsylvania and southern New Jersey. The book Pennsylvania Trees (1928), written by state chief forester Joseph Illick, records willow oak as occurring in Lancaster, Bucks, Chester, Delaware, and Philadelphia counties, chiefly on wet sites, occasionally in drier, upland ones. Much of that area has been built over and developed since World War II, and the tree is now classified as endangered in the state.",
        Longitude: -86.678104,
        Latitude: 33.262937,
      },
      geometry: { type: 'Point', coordinates: [-86.678104, 33.262937] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Willow',
        scientific_name: 'Quercus phellos',
        year_named: 2016.0,
        circumference_in: 220.0,
        height_in: 108.0,
        spread_ft: 121.0,
        total_points: 358.0,
        county: 'Perry',
        year_remeasured: 2021,
        owner: 'Mary Elizabeth Glass',
        nominator: 'Elliott Glass- N',
        sci_lc: 'quercus phellos',
        file_id: 4838.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/field/quercus_phellos/1249580491_0000.jpg?raw=true',
        segmented_path:
          'dataset/segmented/field/quercus_phellos/1249580491_0000.png',
        species_y: 'Quercus phellos',
        source: 'field',
        wiki_summary:
          "Quercus phellos, the willow oak, is a North American species of a deciduous tree in the red oak group of oaks. It is native to the eastern and central United States from Long Island Sound south to northern Florida, and west to southernmost Illinois, Missouri, Oklahoma, and eastern Texas. It is most commonly found growing on lowland floodplains, often along streams, but rarely also in uplands with poor drainage, up to 400 meters (1,300 ft) altitude. Willow oak's natural range extends into southeastern Pennsylvania and southern New Jersey. The book Pennsylvania Trees (1928), written by state chief forester Joseph Illick, records willow oak as occurring in Lancaster, Bucks, Chester, Delaware, and Philadelphia counties, chiefly on wet sites, occasionally in drier, upland ones. Much of that area has been built over and developed since World War II, and the tree is now classified as endangered in the state.",
        Longitude: -87.293827,
        Latitude: 32.639005,
      },
      geometry: { type: 'Point', coordinates: [-87.293827, 32.639005] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Willow',
        scientific_name: 'Quercus phellos',
        year_named: 2017.0,
        circumference_in: 228.0,
        height_in: 106.0,
        spread_ft: 81.0,
        total_points: 354.0,
        county: 'Marshall',
        year_remeasured: 2022,
        owner: 'Snead State Community College',
        nominator: 'Tom Warren- N',
        sci_lc: 'quercus phellos',
        file_id: 4838.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/field/quercus_phellos/1249580491_0000.jpg?raw=true',
        segmented_path:
          'dataset/segmented/field/quercus_phellos/1249580491_0000.png',
        species_y: 'Quercus phellos',
        source: 'field',
        wiki_summary:
          "Quercus phellos, the willow oak, is a North American species of a deciduous tree in the red oak group of oaks. It is native to the eastern and central United States from Long Island Sound south to northern Florida, and west to southernmost Illinois, Missouri, Oklahoma, and eastern Texas. It is most commonly found growing on lowland floodplains, often along streams, but rarely also in uplands with poor drainage, up to 400 meters (1,300 ft) altitude. Willow oak's natural range extends into southeastern Pennsylvania and southern New Jersey. The book Pennsylvania Trees (1928), written by state chief forester Joseph Illick, records willow oak as occurring in Lancaster, Bucks, Chester, Delaware, and Philadelphia counties, chiefly on wet sites, occasionally in drier, upland ones. Much of that area has been built over and developed since World War II, and the tree is now classified as endangered in the state.",
        Longitude: -86.321668,
        Latitude: 34.309564,
      },
      geometry: { type: 'Point', coordinates: [-86.321668, 34.309564] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OSAGE-ORANGE',
        subspecies: 'N/A',
        scientific_name: 'Maclura pomifera',
        year_named: 2012.0,
        circumference_in: 233.0,
        height_in: 59.0,
        spread_ft: 76.0,
        total_points: 311.0,
        county: 'Sumter',
        year_remeasured: 2017,
        owner: 'Don Ward',
        nominator: 'Eleanor Ward',
        sci_lc: 'maclura pomifera',
        file_id: 4370.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/field/maclura_pomifera/1248106412_0000.jpg?raw=true',
        segmented_path:
          'dataset/segmented/field/maclura_pomifera/1248106412_0000.png',
        species_y: 'Maclura pomifera',
        source: 'field',
        wiki_summary:
          'Maclura pomifera, commonly known as the Osage orange, horse apple, hedge, or hedge apple tree is a small deciduous tree or large shrub, typically growing to 8 to 15 metres (30–50 ft) tall. The distinctive fruit, a multiple fruit, is roughly spherical, bumpy, 8 to 15 centimetres (3–6 in) in diameter, and turns bright yellow-green in the fall. The fruits secrete a sticky white latex when cut or damaged. Despite the name "Osage orange", it is not related to the orange. It is a member of the mulberry family, Moraceae. Due to its latex secretions and woody pulp, the fruit is typically not eaten by humans and rarely by foraging animals, giving it distinction as an anachronistic "ghost of evolution".Maclura pomifera has been known by a variety of common names in addition to Osage orange, including hedge apple, horse apple, the French bois d\'arc and English transliterations: bodark and bodock, also translated as "bow-wood"; monkey ball, monkey brains, yellow-wood and mock orange.',
        Longitude: -88.200057,
        Latitude: 32.597481,
      },
      geometry: { type: 'Point', coordinates: [-88.200057, 32.597481] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'PAWPAW',
        subspecies: ' Common',
        scientific_name: 'Asimina triloba',
        year_named: 1997.0,
        circumference_in: 31.0,
        height_in: 55.0,
        spread_ft: 10.0,
        total_points: 89.0,
        county: 'Randolph',
        year_remeasured: 2017,
        owner: 'Tim Coe',
        nominator: 'James Morris, Jr.',
        sci_lc: 'asimina triloba',
        file_id: 70491.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/asimina_triloba/pi2177-01-1.jpg?raw=true',
        segmented_path: 'dataset/segmented/lab/asimina_triloba/pi2177-01-1.png',
        species_y: 'Asimina triloba',
        source: 'lab',
        wiki_summary:
          'Asimina triloba, the American papaw, pawpaw, paw paw, or paw-paw, among many regional names, is a small deciduous tree native to the eastern United States and Canada, producing a large, yellowish-green to brown fruit. It belongs to the genus Asimina in the same plant family (the Annonaceae) as the custard-apple, cherimoya, sweetsop, ylang-ylang, and soursop.\nThe pawpaw is a patch-forming (clonal) understory tree found in well-drained, deep, fertile bottomland and hilly upland habitat, with large, simple leaves. Pawpaw fruits are the largest edible fruit indigenous to the United States (not counting gourds, which are typically considered vegetables rather than fruit for culinary purposes, although in botany they are classified as fruit).Pawpaw fruits have a sweet, custard-like flavor somewhat similar to banana, mango, and pineapple, and are commonly eaten raw, but are also used to make ice cream and baked desserts. The bark, leaves, and fruit have been documented as containing the neurotoxin annonacin, which could cause neurodegeneration.',
        Longitude: -85.464068,
        Latitude: 33.296475,
      },
      geometry: { type: 'Point', coordinates: [-85.464068, 33.296475] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'PEAR',
        subspecies: ' Common',
        scientific_name: 'Pyrus communis',
        year_named: 2003.0,
        circumference_in: 77.0,
        height_in: 57.0,
        spread_ft: 40.0,
        total_points: 144.0,
        county: 'Chilton',
        year_remeasured: 2017,
        owner: 'Isaac & Faye Britton',
        nominator: 'Glenn Barrett & Brian Smith',
        sci_lc: 'pyrus communis',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/pyrus_communis/pyrus_communis.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Pyrus communis, known as the European pear or common pear, is a species of pear native to central and eastern Europe and southwest Asia.\nIt is one of the most important fruits of temperate regions, being the species from which most orchard pear cultivars grown in Europe, North America, and Australia have been developed. Two other species of pear, the Nashi pear (Pyrus pyrifolia) and the hybrid Chinese white or ya pear (Pyrus × bretschneideri, Chinese: 白梨; pinyin: báilí) are more widely grown in East Asia.',
        Longitude: -86.726628,
        Latitude: 32.85406,
      },
      geometry: { type: 'Point', coordinates: [-86.726628, 32.85406] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'PECAN',
        subspecies: 'N/A',
        scientific_name: 'Carya illinoensis',
        year_named: 1999.0,
        circumference_in: 234.0,
        height_in: 122.0,
        spread_ft: 72.0,
        total_points: 374.0,
        county: 'Conecuh',
        year_remeasured: 2017,
        owner: 'Juluin Bush',
        nominator: 'Mason McGowin',
        sci_lc: 'carya illinoensis',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/carya_illinoensis/carya_illinoensis.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'The pecan (Carya illinoinensis) is a species of hickory native to northern Mexico and the southern United States in the region of the Mississippi River. The tree is cultivated for its seed in the southern United States, primarily in Georgia, New Mexico, and Texas, and in Mexico, which produces nearly half of the world total. The seed is an edible nut used as a snack and in various recipes, such as praline candy and pecan pie. The pecan, in various aspects, is included in state symbols of Alabama, Arkansas, California, Oklahoma, and Texas.',
        Longitude: -86.992029,
        Latitude: 31.428293,
      },
      geometry: { type: 'Point', coordinates: [-86.992029, 31.428293] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'PERSIMMON',
        subspecies: 'N/A',
        scientific_name: 'Diospyros virginiana',
        year_named: 2003.0,
        circumference_in: 84.0,
        height_in: 122.0,
        spread_ft: 45.0,
        total_points: 217.0,
        county: 'Lauderdale',
        year_remeasured: 2019,
        owner: 'David Pettus',
        nominator: 'David Pettus',
        sci_lc: 'diospyros virginiana',
        file_id: 77937.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/diospyros_virginiana/pi0196-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/diospyros_virginiana/pi0196-01-1.png',
        species_y: 'Diospyros virginiana',
        source: 'lab',
        wiki_summary:
          "Diospyros virginiana is a persimmon species commonly called the American persimmon, common persimmon, eastern persimmon, simmon, possumwood, possum apples,  or sugar plum. It ranges from southern Connecticut to Florida, and  west to Texas, Louisiana, Oklahoma, Kansas, and Iowa. The tree grows wild but has been cultivated for its fruit and wood since prehistoric times by Native Americans.\nDiospyros virginiana grows to 20 m (66 ft), in well-drained soil. In summer, this species produces fragrant flowers which are dioecious, so one must have both male and female plants to obtain fruit. Most cultivars are parthenocarpic (setting seedless fruit without pollination). The flowers are pollinated by insects and wind. Fruiting typically begins when the tree is about 6 years old.\nThe fruit is round or oval and usually orange-yellow, sometimes bluish, and from 2 to 6 cm (3⁄4 to 2 1⁄4 in) in diameter. In the U.S. South and Midwest, the fruits are referred to as simply persimmons or \"'simmons\", and are popular in desserts and cuisine.\nCommercial varieties include the very productive Early Golden, the productive John Rick, Miller, Woolbright and the Ennis, a seedless variety. Another nickname of the American persimmon, 'date-plum' also refers to a persimmon species found in South Asia, Diospyros lotus.",
        Longitude: -87.650997,
        Latitude: 34.904122,
      },
      geometry: { type: 'Point', coordinates: [-87.650997, 34.904122] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'PINE',
        subspecies: ' Loblolly',
        scientific_name: 'Pinus taeda',
        year_named: 2020.0,
        circumference_in: 193.0,
        height_in: 113.0,
        spread_ft: 65.0,
        total_points: 322.0,
        county: 'Morgan',
        year_remeasured: 2025,
        owner: 'Billy Miles',
        nominator: 'Billy Miles',
        sci_lc: 'pinus taeda',
        file_id: 66678.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/pinus_taeda/wb1148-01-1.jpg?raw=true',
        segmented_path: 'dataset/segmented/lab/pinus_taeda/wb1148-01-1.png',
        species_y: 'Pinus taeda',
        source: 'lab',
        wiki_summary:
          'Pinus taeda, commonly known as loblolly pine, is one of several pines native to the Southeastern United States, from East Texas to Florida, and north to southern New Jersey. The wood industry classifies the species as a southern yellow pine. U.S. Forest Service surveys found that loblolly pine is the second-most common species of tree in the United States, after red maple. For its timber, the pine species is regarded as the most commercially important tree in the Southeastern U.S.The common name loblolly is given because the pine species is found mostly in lowlands and swampy areas.Loblolly pine is the first among over 100 species of Pinus to have its complete genome sequenced. As of March 2014, it was the organism having the largest sequenced genome size. Its genome, with 22 billion base pairs, is seven times larger than that of humans. As of 2018, assembly of the axolotl genome (32Gb) displaced loblolly pine as the largest assembled genome.\n\n',
        Longitude: -86.846402,
        Latitude: 34.454484,
      },
      geometry: { type: 'Point', coordinates: [-86.846402, 34.454484] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'PINE',
        subspecies: ' Longleaf',
        scientific_name: 'Pinus palustris',
        year_named: 2012.0,
        circumference_in: 103.0,
        height_in: 84.0,
        spread_ft: 57.0,
        total_points: 201.0,
        county: 'Baldwin',
        year_remeasured: 2017,
        owner: 'Marino Family Trust',
        nominator: 'Selena C. Vaughn',
        sci_lc: 'pinus palustris',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/pinus_palustris/pinus_palustris.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'The longleaf pine (Pinus palustris) is a pine species native to the Southeastern United States, found along the coastal plain from East Texas to southern Maryland, extending into northern and central Florida. It reaches a height of 30–35 m (98–115 ft) and a diameter of 0.7 m (28 in). In the past, before extensive logging, they reportedly grew to 47 m (154 ft) with a diameter of 1.2 m (47 in). The tree is a cultural symbol of the Southern United States, being the official state tree of Alabama. Contrary to popular belief, this particular species of pine is not officially the state tree of North Carolina.',
        Longitude: -87.746067,
        Latitude: 30.659218,
      },
      geometry: { type: 'Point', coordinates: [-87.746067, 30.659218] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'PINE',
        subspecies: ' Sand',
        scientific_name: 'Pinus clausa',
        year_named: 2008.0,
        circumference_in: 63.0,
        height_in: 54.0,
        spread_ft: 30.0,
        total_points: 125.0,
        county: 'Baldwin',
        year_remeasured: 2021,
        owner: 'Bon Secour Nat’l. Wildlife Refuge',
        nominator: 'Chan West',
        sci_lc: 'pinus clausa',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/pinus_clausa/pinus_clausa.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Pinus clausa is a species of pine endemic to the  Southeastern United States. Its common names include sand pine, Florida spruce pine, Alabama pine, and scrub pine.',
        Longitude: -87.746067,
        Latitude: 30.659218,
      },
      geometry: { type: 'Point', coordinates: [-87.746067, 30.659218] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'PINE',
        subspecies: ' Shortleaf',
        scientific_name: 'Pinus echinata',
        year_named: 2008.0,
        circumference_in: 130.0,
        height_in: 93.0,
        spread_ft: 57.0,
        total_points: 237.0,
        county: 'Madison',
        year_remeasured: 2018,
        owner: 'Buddy Darwin',
        nominator: 'Buddy Darwin',
        sci_lc: 'pinus echinata',
        file_id: 64377.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/pinus_echinata/wb1250-01-1.jpg?raw=true',
        segmented_path: 'dataset/segmented/lab/pinus_echinata/wb1250-01-1.png',
        species_y: 'Pinus echinata',
        source: 'lab',
        wiki_summary:
          'Pinus echinata, the shortleaf pine, is a species of pine native to the eastern United States from southernmost New York, south to northern Florida, west to eastern Oklahoma, and southwest to eastern Texas. Shortleaf pine has the largest range of the southern US yellow pines, but reaches its ecological maxima around western Arkansas in the Ouachita Mountains. The tree is variable in form, sometimes straight, sometimes crooked, with an irregular crown. This tree reaches heights of 20–30 metres (65–100 ft) with a trunk diameter of 0.5–0.9 metres (1 ft 8 in–2 ft 11 in).\nThe leaves are needle-like, in fascicles (bundles) of two and three mixed together, and from 7–11 cm (2 3⁄4–4 1⁄4 in) long. The cones are 4–7 cm (1 1⁄2–2 3⁄4 in) long, with thin scales with a transverse keel and a short prickle.  They open at maturity but are persistent. Shortleaf pine seedlings develop a persistent J-shaped crook near the ground surface. Axillary and other buds form near the crook and initiate growth if the upper stem is killed by fire or is severed. It frequently hybridizes naturally with loblolly pine and pitch pine where their ranges intersect. Hybridization with loblolly pine has become increasingly frequent in recent decades and results in a loss of fire tolerance.This pine is a source of wood pulp, plywood veneer, and lumber for a variety of uses. The shortleaf pine is one of the southern US "southern yellow pines; it is also occasionally called southern yellow pine or the shortstraw pine. \n\nThis pine occupies a variety of habitats from rocky uplands to wet flood plains.  With frequent fire it creates a savanna, with a very diverse under story and prime habitat for the red-cockaded woodpecker.\n\n',
        Longitude: -86.55108,
        Latitude: 34.764238,
      },
      geometry: { type: 'Point', coordinates: [-86.55108, 34.764238] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'PINE',
        subspecies: ' Shortleaf',
        scientific_name: 'Pinus echinata',
        year_named: 2016.0,
        circumference_in: 101.0,
        height_in: 126.0,
        spread_ft: 46.0,
        total_points: 237.0,
        county: 'Covington',
        year_remeasured: 2021,
        owner: 'Thomas W. Savage',
        nominator: 'Thomas W. Savage',
        sci_lc: 'pinus echinate',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/pinus_echinata/pinus_echinata.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Pinus echinata, the shortleaf pine, is a species of pine native to the eastern United States from southernmost New York, south to northern Florida, west to eastern Oklahoma, and southwest to eastern Texas. Shortleaf pine has the largest range of the southern US yellow pines, but reaches its ecological maxima around western Arkansas in the Ouachita Mountains. The tree is variable in form, sometimes straight, sometimes crooked, with an irregular crown. This tree reaches heights of 20–30 metres (65–100 ft) with a trunk diameter of 0.5–0.9 metres (1 ft 8 in–2 ft 11 in).\nThe leaves are needle-like, in fascicles (bundles) of two and three mixed together, and from 7–11 cm (2 3⁄4–4 1⁄4 in) long. The cones are 4–7 cm (1 1⁄2–2 3⁄4 in) long, with thin scales with a transverse keel and a short prickle.  They open at maturity but are persistent. Shortleaf pine seedlings develop a persistent J-shaped crook near the ground surface. Axillary and other buds form near the crook and initiate growth if the upper stem is killed by fire or is severed. It frequently hybridizes naturally with loblolly pine and pitch pine where their ranges intersect. Hybridization with loblolly pine has become increasingly frequent in recent decades and results in a loss of fire tolerance.This pine is a source of wood pulp, plywood veneer, and lumber for a variety of uses. The shortleaf pine is one of the southern US "southern yellow pines; it is also occasionally called southern yellow pine or the shortstraw pine. \n\nThis pine occupies a variety of habitats from rocky uplands to wet flood plains.  With frequent fire it creates a savanna, with a very diverse under story and prime habitat for the red-cockaded woodpecker.\n\n',
        Longitude: -86.448721,
        Latitude: 31.243987,
      },
      geometry: { type: 'Point', coordinates: [-86.448721, 31.243987] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'PINE',
        subspecies: ' Slash',
        scientific_name: 'Pinus elliottii',
        year_named: 2013.0,
        circumference_in: 118.0,
        height_in: 92.0,
        spread_ft: 53.0,
        total_points: 223.0,
        county: 'Mobile',
        year_remeasured: 2018,
        owner: 'Alabama State Port Authority',
        nominator: 'Gena Todia & Fred Nation',
        sci_lc: 'pinus elliottii',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/pinus_elliottii/pinus_elliottii.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Pinus elliottii, commonly known as slash pine, is a conifer tree in the Southeastern United States. Slash pine is named after the "slashes" – swampy ground overgrown with trees and bushes – that constitute its habitat. Other common names include swamp pine, yellow slash pine, and southern Florida pine. Historically, slash pine has been an important economic timber for naval stores, turpentine, and resin. Slash pine has two different varieties: P. e. var. elliottii and P. e. var. densa. Slash pine is known for its unusually high strength, especially for pine. It exceeds many hardwoods and is even comparable to very dense woods such as ironwood.',
        Longitude: -88.196568,
        Latitude: 30.684573,
      },
      geometry: { type: 'Point', coordinates: [-88.196568, 30.684573] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'PINE',
        subspecies: ' Spruce',
        scientific_name: 'Pinus glabra',
        year_named: 1996.0,
        circumference_in: 147.0,
        height_in: 125.0,
        spread_ft: 86.0,
        total_points: 294.0,
        county: 'Russell',
        year_remeasured: 2017,
        owner: 'George Watkins',
        nominator: 'David Boozer & Sharon Clark',
        sci_lc: 'pinus glabra',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/pinus_glabra/pinus_glabra.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Pinus glabra, the spruce pine,  is a tree found on the coastal plains of the southern United States, from southern South Carolina south to northern Florida and west to southern Louisiana. This pine is a straight-growing, medium-sized species, attaining heights of 20–40 m.\nThe leaves are needle-like, in bundles of two, 5–8 cm long, slender (1 mm thick), and glossy dark green. The small, slender cones are 4–6 cm long, with weak prickles on the scales that are soon shed.Pinus glabra differs markedly from most other pines in that it does not occur in largely pure pine forests, but is typically found as scattered trees in moist woodland habitats in mixed hardwood forest. To be able to compete successfully in such habitats, it has adapted to greater shade tolerance than most other pines.',
        Longitude: -85.18698,
        Latitude: 32.289811,
      },
      geometry: { type: 'Point', coordinates: [-85.18698, 32.289811] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'PINE',
        subspecies: ' Virginia',
        scientific_name: 'Pinus virginiana',
        year_named: 2020.0,
        circumference_in: 71.0,
        height_in: 80.0,
        spread_ft: 29.0,
        total_points: 158.0,
        county: 'DeKalb',
        year_remeasured: 2025,
        owner: 'DeSoto State Park',
        nominator: 'Dan Green',
        sci_lc: 'pinus virginiana',
        file_id: 66918.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/pinus_virginiana/wb1481-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/pinus_virginiana/wb1481-01-1.png',
        species_y: 'Pinus virginiana',
        source: 'lab',
        wiki_summary:
          'Pinus virginiana, the Virginia pine, scrub pine, Jersey pine, is a medium-sized tree, often found on poorer soils from Long Island in southern New York south through the Appalachian Mountains to western Tennessee and Alabama. The usual size range for this pine is 9–18 m, (18–59 feet) but can grow larger under optimum conditions. The trunk can be as large as 20 inches diameter. This tree prefers well-drained loam or clay, but will also grow on very poor, sandy soil, where it remains small and stunted. The typical life span is 65 to 90 years.\nThe short (4–8 cm), yellow-green needles are paired in fascicles and are often twisted. Pinecones are 4–7 cm long and may persist on the tree for many years, often (though not always) releasing their seeds in the second year. In growth habit, some trees may be inclined with twisted trunks.\nThis pine is useful for reforesting and provides nourishment for wildlife. Its other main use is on Christmas tree farms, despite having sharp-tipped needles and yellowish winter color. It also can provide wood pulp and lumber. Like some other southern yellow pines, Virginia pine lumber case hardens. That is, it becomes very hard over time during wood drying. Wood from Virginia pine is not normally considered to resist rot unless treated with preservatives.',
        Longitude: -85.803992,
        Latitude: 34.460929,
      },
      geometry: { type: 'Point', coordinates: [-85.803992, 34.460929] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'PLUM',
        subspecies: ' American',
        scientific_name: 'Prunus americana',
        year_named: 2013.0,
        circumference_in: 17.0,
        height_in: 30.0,
        spread_ft: 25.0,
        total_points: 53.0,
        county: 'Talladega',
        year_remeasured: 2018,
        owner: 'Camp Mac',
        nominator: 'John McBride',
        sci_lc: 'prunus americana',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/prunus_americana/prunus_americana.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          "Prunus americana, commonly called the American plum, wild plum, or Marshall's large yellow sweet plum, is a species of Prunus native to North America from Saskatchewan and Idaho south to New Mexico and east to Québec, Maine and Florida.Prunus americana has often been planted outside its native range and sometimes escapes cultivation. It is commonly confused with the Canada plum (Prunus nigra), although the fruit is smaller and rounder and bright red as opposed to yellow. Many cultivated varieties have been derived from this species. It forms an excellent stock upon which to graft the domestic plum.",
        Longitude: -86.175805,
        Latitude: 33.369277,
      },
      geometry: { type: 'Point', coordinates: [-86.175805, 33.369277] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'PLUM',
        subspecies: ' American',
        scientific_name: 'Prunus americana',
        year_named: 2007.0,
        circumference_in: 26.0,
        height_in: 19.0,
        spread_ft: 22.0,
        total_points: 51.0,
        county: 'Elmore',
        year_remeasured: 2017,
        owner: 'Ft. Toulouse Park',
        nominator: 'Lynn Justiss & Ned Jenkins',
        sci_lc: 'prunus americana',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/prunus_americana/prunus_americana.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          "Prunus americana, commonly called the American plum, wild plum, or Marshall's large yellow sweet plum, is a species of Prunus native to North America from Saskatchewan and Idaho south to New Mexico and east to Québec, Maine and Florida.Prunus americana has often been planted outside its native range and sometimes escapes cultivation. It is commonly confused with the Canada plum (Prunus nigra), although the fruit is smaller and rounder and bright red as opposed to yellow. Many cultivated varieties have been derived from this species. It forms an excellent stock upon which to graft the domestic plum.",
        Longitude: -86.142739,
        Latitude: 32.597229,
      },
      geometry: { type: 'Point', coordinates: [-86.142739, 32.597229] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'PLUM',
        subspecies: ' Chickasaw',
        scientific_name: 'Prunus angustifolia',
        year_named: 2007.0,
        circumference_in: 21.0,
        height_in: 17.0,
        spread_ft: 24.0,
        total_points: 44.0,
        county: 'Baldwin',
        year_remeasured: 2017,
        owner: 'Alabama Dep’t. Of Conservation',
        nominator: 'Maureen Nation',
        sci_lc: 'prunus angustifolia',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/prunus_angustifolia/prunus_angustifolia.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Prunus angustifolia, known commonly as Chickasaw plum, Cherokee plum, Florida sand plum, sandhill plum, or sand plum, is a North American species of plum-bearing tree.  It was originally cultivated by Native Americans before the arrival of Europeans  While Prunus is the classical name for European plums, angustifolia refers to its narrow leaves.',
        Longitude: -87.746067,
        Latitude: 30.659218,
      },
      geometry: { type: 'Point', coordinates: [-87.746067, 30.659218] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Chinkapin',
        scientific_name: 'Quercus muehlenbergii',
        year_named: 2011.0,
        circumference_in: 141.0,
        height_in: 129.0,
        spread_ft: 95.0,
        total_points: 294.0,
        county: 'Lauderdale',
        year_remeasured: 2021,
        owner: 'Joe Wheeler State Park',
        nominator: 'Jason Shelton',
        sci_lc: 'quercus muehlenbergii',
        file_id: 71685.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/quercus_muehlenbergii/wb1529-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/quercus_muehlenbergii/wb1529-01-1.png',
        species_y: 'Quercus muehlenbergii',
        source: 'lab',
        wiki_summary:
          'Quercus muehlenbergii, the chinkapin or chinquapin oak, is a deciduous species of tree in the white oak group (Quercus sect. Quercus). The species was often called Quercus acuminata in older literature. Quercus muehlenbergii (often misspelled as muhlenbergii) is native to eastern and central North America. It ranges from Vermont to Minnesota, south to the Florida panhandle, and west to New Mexico in the United States. In Canada it is only found in southern Ontario, and in Mexico it ranges from Coahuila south to Hidalgo.\n\n',
        Longitude: -87.650997,
        Latitude: 34.904122,
      },
      geometry: { type: 'Point', coordinates: [-87.650997, 34.904122] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Darlington',
        scientific_name: 'Quercus hemisphaerica',
        year_named: 2009.0,
        circumference_in: 251.0,
        height_in: 91.0,
        spread_ft: 96.0,
        total_points: 366.0,
        county: 'Hale',
        year_remeasured: 2019,
        owner: 'David & Christie Krystofiak',
        nominator: 'Tim Washburne',
        sci_lc: 'quercus hemisphaerica',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/quercus_hemisphaerica/quercus_hemisphaerica.PNG?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Quercus hemisphaerica (sand laurel oak, laurel oak, Darlington oak, laurel-leaf oak) is a species of oak native to the southeastern and south-central United States, from Texas to Delaware. It is in the red oak section Quercus sect. Lobatae. It is often confused with and closely related to the Quercus laurifolia (swamp laurel oak) in which it differs in several key characteristics.\nQuercus hemisphaerica is a medium-sized evergreen to semi-evergreen tree which can grow as tall as 115 feet (35 m) tall with a 5-foot (1.5 m) trunk diameter, although it is more commonly around 60 to 65 feet (18 m-20 m) tall. The leaves are entire, without teeth except one apical awn (rarely with a few teeth near apex), mostly elliptical or narrowly ovate, and 1.2 to 4.7 inches (3 cm to 12 cm) long by 0.4 to 1.6 inches (1 cm to 4 cm) wide. The petiole is very short ranging from 1/25 to 1/5 of an inch(1 mm to 5 mm) long and the leaf base is obtuse to rounded. The acorns are hemispheric in shape and 0.35 to 0.6 inches(9 to 16.5 mm) by 0.35 to 0.6 inches(9 to 16.5 mm). The acorns take 18 months to mature and are 1/4 to 1/3 covered by a saucer to bowl shaped cap.It grows in somewhat xeric sandy soils, sand hills, and sometimes on hillsides.\nThere is at least one known hybrid involving Quercus hemisphaerica which is with Q. laevis (Q. × mellichampii Trel.).',
        Longitude: -87.623061,
        Latitude: 32.752796,
      },
      geometry: { type: 'Point', coordinates: [-87.623061, 32.752796] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Durand',
        scientific_name: 'Quercus durandii',
        year_named: 2007.0,
        circumference_in: 162.0,
        height_in: 107.0,
        spread_ft: 62.0,
        total_points: 285.0,
        county: 'Wilcox',
        year_remeasured: 2017,
        owner: 'U. S. Army Corps of Engineers',
        nominator: 'Jason Ledbetter',
        sci_lc: 'quercus durandii',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/quercus_durandii/quercus_durandii.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Quercus sinuata is a North American species of oak comprising two distinct varieties, Quercus sinuata var. sinuata and Quercus sinuata var. breviloba. Morphologically intermediate forms may occur where range overlap brings the two taxa together. Quercus sinuata var. breviloba is native to central and north central Texas, south central and southwest Oklahoma, and to Coahuila, Nuevo León, and Tamaulipas in northern Mexico. Quercus sinuata var. sinuata is native to the south-central and southeastern United States from central Texas and southwestern Arkansas to the Carolinas. Their respective ranges intersect in the Hill Country of central Texas, where streams flowing through dry, brushy limestone hills create a mosaic of wet and well drained habitats.\n\n',
        Longitude: -87.302205,
        Latitude: 31.99033,
      },
      geometry: { type: 'Point', coordinates: [-87.302205, 31.99033] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Durand',
        scientific_name: 'Quercus durandii',
        year_named: 2020.0,
        circumference_in: 180.0,
        height_in: 90.0,
        spread_ft: 95.0,
        total_points: 294.0,
        county: 'Greene',
        year_remeasured: 2025,
        owner: 'Bethany Holdings',
        nominator: 'Steve Gardiner',
        sci_lc: 'quercus durandii',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/quercus_durandii/quercus_durandii.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Quercus sinuata is a North American species of oak comprising two distinct varieties, Quercus sinuata var. sinuata and Quercus sinuata var. breviloba. Morphologically intermediate forms may occur where range overlap brings the two taxa together. Quercus sinuata var. breviloba is native to central and north central Texas, south central and southwest Oklahoma, and to Coahuila, Nuevo León, and Tamaulipas in northern Mexico. Quercus sinuata var. sinuata is native to the south-central and southeastern United States from central Texas and southwestern Arkansas to the Carolinas. Their respective ranges intersect in the Hill Country of central Texas, where streams flowing through dry, brushy limestone hills create a mosaic of wet and well drained habitats.\n\n',
        Longitude: -87.964201,
        Latitude: 32.844497,
      },
      geometry: { type: 'Point', coordinates: [-87.964201, 32.844497] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Georgia',
        scientific_name: 'Quercus georgiana',
        year_named: 2014.0,
        circumference_in: 32.0,
        height_in: 45.0,
        spread_ft: 29.0,
        total_points: 84.0,
        county: 'Lee',
        year_remeasured: 2019,
        owner: 'Davis Arboretum Auburn University',
        nominator: 'Patrick Thompson',
        sci_lc: 'quercus georgiana',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/quercus_georgiana/quercus_georgiana.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Quercus georgiana, the Georgia oak or Stone Mountain oak, is a rare deciduous red oak, native to the southeastern United States.',
        Longitude: -85.353048,
        Latitude: 32.604064,
      },
      geometry: { type: 'Point', coordinates: [-85.353048, 32.604064] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Laurel',
        scientific_name: 'Quercus laurifolia',
        year_named: 2010.0,
        circumference_in: 289.0,
        height_in: 95.0,
        spread_ft: 88.0,
        total_points: 406.0,
        county: 'Marengo',
        year_remeasured: 2020,
        owner: 'Mayton',
        nominator: 'Kim Mayton',
        sci_lc: 'quercus laurifolia',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/quercus_laurifolia/quercus_laurifolia.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          "Quercus laurifolia (swamp laurel oak, diamond-leaf oak, water oak, obtusa oak, laurel oak) is a medium-sized semi-evergreen oak in the red oak section Quercus sect. Lobatae. It is native to the southeastern and south-central the United States, from coastal Virginia to central Florida and west to southeast Texas. There are reports of the species growing in Pennsylvania and New Jersey, but these probably represent introductions.\nQuercus laurifolia is a tree growing to 65–80 feet (20–24 meters) (rarely to 130 feet (40 meters)) tall, with a large, circular crown. The leaves are broad lanceolate, 1–5 inches (2.5–12.7 centimetres) long and 0.5–1.75 inches (1.3–4.4 centimetres) broad, and unlobed (very rarely three-lobed) with an entire margin and a bristle tip; they typically fall just as the new leaves start to emerge in spring. The acorns, borne in a shallow cup, are hemispherical, 0.35–0.5 inches (8.9–12.7 millimetres) long, green, maturing blackish-brown about 18 months after pollination. Despite their bitter kernel, they are eaten by deer, squirrels and birds. Acorn production is often heavy, enhancing the species' value for wildlife. The seedlings show embryo dormancy and germinate the following spring after fall ripening; germination is hypogeal.\nSwamp laurel oak grows rapidly and usually matures in about 50 years which has led to its wide use as an ornamental. It is host to the general oak-feeding insects but has no serious insect problems. Several species of Curculio weevils infest the acorns.\nThe botanist C.J. Burke suggested that swamp laurel oak is of hybrid origin having been derived from willow oak (Quercus phellos) and water oak (Quercus nigra); it is not found outside the ranges of the two supposed parental species. This conclusion was based on an index from leaf-shape on seedlings grown from acorns. However, this theory has not achieved wide support, with current authors accepting Quercus laurifolia as a distinct species (e.g. Flora of North America).Known hybrids with Quercus laurifolia as one parent are with Q. falcata (Q × beaumontiana Sarg.), Q. incana (Q. × atlantica Ashe), and Q. marilandica (Q. × diversiloba Tharp ex A. Camus).",
        Longitude: -87.791091,
        Latitude: 32.247591,
      },
      geometry: { type: 'Point', coordinates: [-87.791091, 32.247591] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Live',
        scientific_name: 'Quercus virginiana',
        year_named: 2013.0,
        circumference_in: 363.0,
        height_in: 82.0,
        spread_ft: 136.0,
        total_points: 479.0,
        county: 'Mobile',
        year_remeasured: 2018,
        owner: 'Sandy Howard',
        nominator: 'Donald E. Nelson',
        sci_lc: 'quercus virginiana',
        file_id: 72681.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/quercus_virginiana/wb1373-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/quercus_virginiana/wb1373-01-1.png',
        species_y: 'Quercus virginiana',
        source: 'lab',
        wiki_summary:
          'Quercus virginiana, also known as the southern live oak, is an evergreen oak tree endemic to the Southeastern United States. Though many other species are loosely called live oak, the southern live oak is particularly iconic of the Old South. Many very large and old specimens of live oak can be found today in the Deep South region of the United States.',
        Longitude: -88.196568,
        Latitude: 30.684573,
      },
      geometry: { type: 'Point', coordinates: [-88.196568, 30.684573] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Myrtle',
        scientific_name: 'Quercus myrtifolia',
        year_named: 2007.0,
        circumference_in: 27.0,
        height_in: 35.0,
        spread_ft: 40.0,
        total_points: 72.0,
        county: 'Baldwin',
        year_remeasured: 2017,
        owner: 'Fort Morgan State Historic Site',
        nominator: 'Dr. Harry Larsen & Fred Nation',
        sci_lc: 'quercus myrtifolia',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/quercus_myrtifolia/quercus_myrtifolia.gif?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Quercus myrtifolia, the myrtle oak, is a North American species of oaks in the beech family. It is native to the southeastern United States (Mississippi, Alabama, Florida, Georgia, South Carolina). It is often found in coastal areas on sandy soils.Quercus myrtifolia is an evergreen tree that can reach 12 meters (40 feet) tall or shrub in drier sites. It has leaves with no teeth or lobes, hairless on the upperside and also on the underside except along the veins.',
        Longitude: -87.746067,
        Latitude: 30.659218,
      },
      geometry: { type: 'Point', coordinates: [-87.746067, 30.659218] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Northern Red',
        scientific_name: 'Quercus rubra',
        year_named: 2009.0,
        circumference_in: 130.0,
        height_in: 125.0,
        spread_ft: 95.0,
        total_points: 279.0,
        county: 'Marion',
        year_remeasured: 2019,
        owner: 'James Ross Markham',
        nominator: 'Tony Avery',
        sci_lc: 'quercus rubra',
        file_id: 4386.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/field/quercus_rubra/1248106564_0000.jpg?raw=true',
        segmented_path:
          'dataset/segmented/field/quercus_rubra/1248106564_0000.png',
        species_y: 'Quercus rubra',
        source: 'field',
        wiki_summary:
          'Quercus rubra, the northern red oak, is an oak tree in the red oak group (Quercus section Lobatae). It is a native of North America, in the eastern and central United States and southeast and south-central Canada. It grows from the north end of the Great Lakes, east to Nova Scotia, south as far as Georgia, Mississippi, Alabama, and Louisiana, and west to Oklahoma, Kansas, Nebraska, and Minnesota. It has been introduced to small areas in Western Europe, where it can frequently be seen cultivated in gardens and parks. It prefers good soil that is slightly acidic. Often simply called red oak, northern red oak is so named to distinguish it from southern red oak (Q. falcata), also known as the Spanish oak. It is sometimes called champion oak. It is also the state tree of New Jersey and the provincial tree of Prince Edward Island.',
        Longitude: -87.881551,
        Latitude: 34.138219,
      },
      geometry: { type: 'Point', coordinates: [-87.881551, 34.138219] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Nuttall',
        scientific_name: 'Quercus texana',
        year_named: 2017.0,
        circumference_in: 83.0,
        height_in: 73.0,
        spread_ft: 52.0,
        total_points: 169.0,
        county: 'Lee',
        year_remeasured: 2022,
        owner: 'Auburn University',
        nominator: 'Morgan Beadles- N',
        sci_lc: 'quercus texana',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/quercus_texana/quercus_texana.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          "Quercus texana, commonly known as Nuttall's oak, is a fast-growing, large deciduous oak tree.\n\nQuercus texana is native to the south-central United States primarily in the lower Mississippi River Valley in Louisiana, Arkansas, Mississippi, Alabama, and western Tennessee.  There are additional populations in eastern Texas, southeastern Oklahoma, southeastern Missouri, far western Kentucky, and the southernmost tip of Illinois.Quercus texana is a tree up to 25 meters (83 feet) tall, with dark brown bark.  It has leaves with sharp pointed lobes somewhat similar to those of the Georgia oak (Quercus georgiana) and pin oak (Quercus palustris). It is fast-growing and usually has nice red fall colors, much more reliably so than the more popular pin oak. It is still relatively obscure in the horticultural industry but is slowly gaining popularity due to its fast growth rate, ease of transplanting, good fall colors and ability to grow in wet soils.\nThis species was for years erroneously called Quercus nuttallii, but it is now known as Quercus texana; this has created much confusion with Texas red oak which was known as Quercus texana but is now known as Quercus buckleyi.",
        Longitude: -85.353048,
        Latitude: 32.604064,
      },
      geometry: { type: 'Point', coordinates: [-85.353048, 32.604064] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Overcup',
        scientific_name: 'Quercus lyrata',
        year_named: 2013.0,
        circumference_in: 204.0,
        height_in: 117.0,
        spread_ft: 93.0,
        total_points: 344.0,
        county: 'Dallas',
        year_remeasured: 2018,
        owner: 'Tom Wasmer',
        nominator: 'Tom Wasmer',
        sci_lc: 'quercus lyrata',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/quercus_lyrata/quercus_lyrata.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Quercus lyrata, the overcup oak, is an oak in the white oak group (Quercus sect. Quercus). The common name, overcup oak, refers to its acorns that are mostly enclosed within the acorn cup. It is native to lowland wetlands in the eastern and south-central United States, in all the coastal states from New Jersey to Texas, inland as far as Oklahoma, Missouri, and Illinois. There are historical reports of it growing in Iowa, but the species appears to have been extirpated there. It is a slow-growing tree that often takes 25 to 30 years to mature. It has an estimated lifespan of 400 years.',
        Longitude: -87.114356,
        Latitude: 32.33354,
      },
      geometry: { type: 'Point', coordinates: [-87.114356, 32.33354] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Post',
        scientific_name: 'Quercus stellata',
        year_named: 2015.0,
        circumference_in: 255.0,
        height_in: 95.0,
        spread_ft: 122.0,
        total_points: 381.0,
        county: 'Colbert',
        year_remeasured: 2020,
        owner: 'Dale & Karen Smith',
        nominator: 'Karen Smith',
        sci_lc: 'quercus stellata',
        file_id: 72441.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/quercus_stellata/wb1214-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/quercus_stellata/wb1214-01-1.png',
        species_y: 'Quercus stellata',
        source: 'lab',
        wiki_summary:
          'Quercus stellata, the post oak or iron oak, is a North American species of oak in the white oak section. It is a slow-growing oak that lives in dry areas on the edges of fields, tops of ridges also grows in poor soils, and is resistant to rot, fire, and drought. Interbreeding occurs among white oaks, thus many hybrid species combinations occur.\n\n',
        Longitude: -87.801457,
        Latitude: 34.703112,
      },
      geometry: { type: 'Point', coordinates: [-87.801457, 34.703112] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Post',
        scientific_name: 'Quercus lyrata',
        year_named: 2017.0,
        circumference_in: 225.0,
        height_in: 128.0,
        spread_ft: 97.0,
        total_points: 377.0,
        county: 'Hale',
        year_remeasured: 2022,
        owner: 'Alan Dennis',
        nominator: 'Ethan Barrett- N',
        sci_lc: 'quercus lyrata',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/quercus_lyrata/quercus_lyrata.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Quercus lyrata, the overcup oak, is an oak in the white oak group (Quercus sect. Quercus). The common name, overcup oak, refers to its acorns that are mostly enclosed within the acorn cup. It is native to lowland wetlands in the eastern and south-central United States, in all the coastal states from New Jersey to Texas, inland as far as Oklahoma, Missouri, and Illinois. There are historical reports of it growing in Iowa, but the species appears to have been extirpated there. It is a slow-growing tree that often takes 25 to 30 years to mature. It has an estimated lifespan of 400 years.',
        Longitude: -87.623061,
        Latitude: 32.752796,
      },
      geometry: { type: 'Point', coordinates: [-87.623061, 32.752796] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Sand Live',
        scientific_name: 'Quercus geminata',
        year_named: 1998.0,
        circumference_in: 184.0,
        height_in: 66.0,
        spread_ft: 110.0,
        total_points: 278.0,
        county: 'Mobile',
        year_remeasured: 2018,
        owner: 'Lotawanna Lambert',
        nominator: 'Richie Nell',
        sci_lc: 'quercus geminata',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/quercus_geminata/quercus_geminata.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          "Quercus geminata, commonly called sand live oak, is an evergreen oak tree native to the coastal regions of the subtropical southeastern United States, along the Atlantic Coast from southern Florida northward to southeastern Virginia and along the Gulf Coast westward to southern Mississippi, on seacoast dunes and on white sands in evergreen oak scrubs.A small- to medium-sized tree, the sand live oak is scrubby and forms thickets. The bark is dark, thick, furrowed, and roughly ridged. The leaves are thick, leathery, and coarsely veined, with extremely revolute margins, giving them the appearance of inverted shallow bowls; their tops dark green, their bottoms dull gray and very tightly tomentose, and their petioles densely pubescent, they are simple and typically flat with bony-opaque margins, having a length of 0.75–4.5 inches (2–12 cm) and a width of 0.2–1.5 inches (0.5–4 cm).  The male flowers are green hanging catkins.  The acorns are small, 0.5–1 inch (1–2.5 cm), oblong-ellipsoid or ovoid, and are commonly born in pairs on peduncles of varying lengths.In coastal Florida's evergreen oak scrub, the Sand Live Oak is a ubiquitous and abundant species; the threatened Florida scrub-jay is found only in Florida scrub.  Live oaks, having characteristics of the sand live oak and the southern live oak (Q. virginiana), grow further inland.  It is believed that these specimens are hybrids of Q. geminata and Q. virginiana. While hybridization does occur between Q. geminata and Q. virginiana, the two species are genetically and morphologically distinct. The Cuban oak, Q. sagraeana, has been purported to be a hybrid between the sand live oak and Q. oleoides, but recent evidence suggests that the Cuban oak is a separate species without hybrid origin.",
        Longitude: -88.196568,
        Latitude: 30.684573,
      },
      geometry: { type: 'Point', coordinates: [-88.196568, 30.684573] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Sand Post',
        scientific_name: 'Quercus margaretta',
        year_named: 1982.0,
        circumference_in: 101.0,
        height_in: 63.0,
        spread_ft: 76.0,
        total_points: 183.0,
        county: 'Covington',
        year_remeasured: 2018,
        owner: 'Solon Dixon Forestry Ed. Center',
        nominator: 'Dr. Harry Larsen',
        sci_lc: 'quercus margaretta',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/quercus_margaretta/quercus_margaretta.png?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Quercus margarettae, the sand post oak or dwarf post oak, is a North American species of oak in the beech family. It is native to the southeastern and south-central United States from Virginia to Florida and west as far as Texas and Oklahoma. There are historical reports of the species growing in New York State, but it has not been seen there in years.Quercus margarettae is a deciduous shrub or small tree growing up to 12 meters (40 feet) tall. Bark is gray and scaly. Leaves are up to 135 mm (5.4 inches) long, bipinnately lobed with rounded lobes. The plant grows in sandy or gravelly soil.',
        Longitude: -86.448721,
        Latitude: 31.243987,
      },
      geometry: { type: 'Point', coordinates: [-86.448721, 31.243987] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Scarlet',
        scientific_name: 'Quercus coccinea',
        year_named: 2011.0,
        circumference_in: 170.0,
        height_in: 118.0,
        spread_ft: 99.0,
        total_points: 313.0,
        county: 'Jackson',
        year_remeasured: 2021,
        owner: 'Scarlet Oak Farms',
        nominator: 'Jason Shelton',
        sci_lc: 'quercus coccinea',
        file_id: 4558.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/field/quercus_coccinea/1249060512_0000.jpg?raw=true',
        segmented_path:
          'dataset/segmented/field/quercus_coccinea/1249060512_0000.png',
        species_y: 'Quercus coccinea',
        source: 'field',
        wiki_summary:
          'Quercus coccinea, the scarlet oak, is an oak in the red oak section Quercus sect. Lobatae.  The scarlet oak can be mistaken for the pin oak, the black oak, or occasionally the red oak. On scarlet oak the sinuses between lobes are "C"-shaped in comparison to pin oak (Q. palustris), which has "U"-shaped sinuses and the acorns are half covered by a deep cap.Scarlet oak is mainly native to the central and eastern United States, from southern Maine west to Wisconsin, Michigan and Missouri, and south as far as Louisiana, Alabama, and Georgia. It occurs on dry, sandy, usually acidic soils. It is often an important canopy species in an oak–heath forest.',
        Longitude: -85.9774,
        Latitude: 34.763522,
      },
      geometry: { type: 'Point', coordinates: [-85.9774, 34.763522] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Shingle',
        scientific_name: 'Quercus imbricaria',
        year_named: 2004.0,
        circumference_in: 152.0,
        height_in: 68.0,
        spread_ft: 102.0,
        total_points: 246.0,
        county: 'Lawrence',
        year_remeasured: 2017,
        owner: 'Joe Wheeler State Park',
        nominator: 'Jack Paul',
        sci_lc: 'quercus imbricaria',
        file_id: 4578.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/field/quercus_imbricaria/1249060909_0000.jpg?raw=true',
        segmented_path:
          'dataset/segmented/field/quercus_imbricaria/1249060909_0000.png',
        species_y: 'Quercus imbricaria',
        source: 'field',
        wiki_summary:
          'Quercus imbricaria, the shingle oak, is a deciduous tree in the red oak group of oaks.  It is native primarily to the Midwestern and Upper South regions of North America, from southern New York west to northern Illinois and eastern Kansas, and south to central Alabama and Arkansas.  It is most commonly found growing in uplands with good drainage, less often along lowland streams, at 100–700 m altitude.\nQuercus imbricaria is a medium-sized tree growing to 20 meters (67 feet) tall, with a trunk up to 1 meter (40 inches) in diameter (rarely 1.4 meters, 56 inches).  It is distinguished from most other oaks by its leaves, which are shaped like laurel leaves, 8–20 cm (4–10 inches) long and 1.5–7.5 cm (0.6–3.0 inches) broad with an untoothed margin; they are bright green above, paler and somewhat downy beneath. The fruit is an acorn, 9–18 mm long and wide with a shallow cup; they are mature about 18 months after pollination.  They are an important food for squirrels and some birds.',
        Longitude: -87.321865,
        Latitude: 34.529776,
      },
      geometry: { type: 'Point', coordinates: [-87.321865, 34.529776] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Shumard',
        scientific_name: 'Quercus shumardii',
        year_named: null,
        circumference_in: 163.0,
        height_in: 146.0,
        spread_ft: 99.0,
        total_points: 334.0,
        county: 'Marengo',
        year_remeasured: 2020,
        owner: 'The Westervelt Company',
        nominator: 'Chris Chambers',
        sci_lc: 'quercus shumardii',
        file_id: 72321.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/quercus_shumardii/ny1156-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/quercus_shumardii/ny1156-01-1.png',
        species_y: 'Quercus shumardii',
        source: 'lab',
        wiki_summary:
          "Quercus shumardii, the Shumard oak, spotted oak, Schneck oak, Shumard red oak, or swamp red oak, is one of the largest of the oak species in the red oak group (Quercus section Lobatae). It is closely related to Quercus buckleyi (Texas red oak), Quercus texana (Nuttall's red oak), and Quercus gravesii (Chisos red oak).",
        Longitude: -87.791091,
        Latitude: 32.247591,
      },
      geometry: { type: 'Point', coordinates: [-87.791091, 32.247591] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Southern Red',
        scientific_name: 'Quercus falcata',
        year_named: 1987.0,
        circumference_in: 300.0,
        height_in: 66.0,
        spread_ft: 79.0,
        total_points: 386.0,
        county: 'Pike',
        year_remeasured: 2018,
        owner: 'Hunter J. Flack',
        nominator: 'Silas Bonner',
        sci_lc: 'quercus falcata',
        file_id: 70598.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/quercus_falcata/wb1121-01-1.jpg?raw=true',
        segmented_path: 'dataset/segmented/lab/quercus_falcata/wb1121-01-1.png',
        species_y: 'Quercus falcata',
        source: 'lab',
        wiki_summary:
          'Quercus falcata,  also called southern red oak, spanish oak, bottomland red oak or three-lobed red oak is an oak (part of the genus Quercus). Native to the southeastern United States, it gets its name the "Spanish Oak" as these are the areas of early Spanish colonies, whilst "southern red oak" comes from both its range and leaf color during late summer and fall.The southern red oak is a deciduous angiosperm, so has leaves that die after each growing period and come back in the next period of growth.',
        Longitude: -85.941997,
        Latitude: 31.798726,
      },
      geometry: { type: 'Point', coordinates: [-85.941997, 31.798726] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Swamp Chestnut',
        scientific_name: 'Quercus michauxii',
        year_named: 2007.0,
        circumference_in: 283.0,
        height_in: 124.0,
        spread_ft: 119.0,
        total_points: 437.0,
        county: 'Cleburne',
        year_remeasured: 2021,
        owner: 'Cleburne County Road Dep’t.',
        nominator: 'Jake Holloway',
        sci_lc: 'quercus michauxii',
        file_id: 71333.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/quercus_michauxii/wb1025-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/quercus_michauxii/wb1025-01-1.png',
        species_y: 'Quercus michauxii',
        source: 'lab',
        wiki_summary:
          'Quercus michauxii, the swamp chestnut oak, is a species of oak in the white oak section Quercus section Quercus in the beech family. It is native to bottomlands and wetlands in the southeastern and midwestern United States, in coastal states from New Jersey to Texas, inland primarily in the Mississippi–Ohio Valley as far as Oklahoma, Missouri, Illinois, and Indiana.',
        Longitude: -85.516109,
        Latitude: 33.671981,
      },
      geometry: { type: 'Point', coordinates: [-85.516109, 33.671981] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Swamp White',
        scientific_name: 'Quercus bicolor',
        year_named: 2007.0,
        circumference_in: 122.0,
        height_in: 87.0,
        spread_ft: 29.0,
        total_points: 216.0,
        county: 'Madison',
        year_remeasured: 2021,
        owner: 'Goldsmith',
        nominator: 'Susan Weber',
        sci_lc: 'quercus bicolor',
        file_id: 4583.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/field/quercus_bicolor/1249060941_0000.jpg?raw=true',
        segmented_path:
          'dataset/segmented/field/quercus_bicolor/1249060941_0000.png',
        species_y: 'Quercus bicolor',
        source: 'field',
        wiki_summary:
          "Quercus bicolor, the swamp white oak, is a North American species of medium-sized trees in the beech family. It is a common element of America's north central and northeastern mixed forests. It can survive in a variety of habitats. It forms hybrids with bur oak where they occur together in the wild.",
        Longitude: -86.55108,
        Latitude: 34.764238,
      },
      geometry: { type: 'Point', coordinates: [-86.55108, 34.764238] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'MAGNOLIA',
        subspecies: ' Cucumber',
        scientific_name: 'Magnolia acuminata',
        year_named: 1993.0,
        circumference_in: 136.0,
        height_in: 112.0,
        spread_ft: 59.0,
        total_points: 263.0,
        county: 'Madison',
        year_remeasured: 2017,
        owner: 'City of Huntsville',
        nominator: 'Susan Weber & Layne Vaughan',
        sci_lc: 'magnolia acuminata',
        file_id: 62572.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/magnolia_acuminata/wb1220-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/magnolia_acuminata/wb1220-01-1.png',
        species_y: 'Magnolia acuminata',
        source: 'lab',
        wiki_summary:
          'Magnolia acuminata, commonly called the cucumber tree (often spelled as a single word "cucumbertree"), cucumber magnolia or blue magnolia, is one of the largest magnolias, and one of the cold-hardiest. It is a large forest tree of the Eastern United States and Southern Ontario in Canada. It is a tree that tends to occur singly as scattered specimens, rather than in groves.The cucumber tree is native primarily within the Appalachian belt, including the Allegheny Plateau and Cumberland Plateau, up to western Pennsylvania and New York. There are also numerous disconnected outlying populations through much of the southeastern U.S., and a few small populations in Southern Ontario. In Canada, the cucumber tree is listed as an endangered species and is protected under the Canadian Species at Risk Act.  In 1993 The North American Native Plant Society purchased Shining Tree Woods to preserve a stand of Magnolia acuminata, which is also known as "The Shining Tree".\nThe leaves are deciduous simple and alternate, oval to oblong, 12–25 cm long and 6–12 cm wide, with smooth margins and downy on the underside. They come in two forms, acuminate at both ends, or moderately cordate at the base (these are usually only formed high in the tree).\n\nUnlike most magnolias, the flowers are not showy. They are typically small, yellow-green, and borne high in the tree in April through June. The leaves of Magnolia acuminata are pointed at the tip and provide it with its name - \'acuminate\' means tapering to a fine point. The name Cucumber Tree refers to the unripe fruit, which is green and often shaped like a small cucumber; the fruit matures to a dark red color and is 6–8 cm long and 4 cm broad, with the individual carpels splitting open to release the bright red seeds, 10-60 per fruit. The ripe fruit is a striking reddish orange color.',
        Longitude: -86.55108,
        Latitude: 34.764238,
      },
      geometry: { type: 'Point', coordinates: [-86.55108, 34.764238] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'MAGNOLIA',
        subspecies: ' Pyramid',
        scientific_name: 'Magnolia pyramidata',
        year_named: 2011.0,
        circumference_in: 41.0,
        height_in: 92.0,
        spread_ft: 24.0,
        total_points: 139.0,
        county: 'Wilcox',
        year_remeasured: 2016,
        owner: 'Tommy Lawler',
        nominator: 'Tommy Lawler',
        sci_lc: 'magnolia pyramidata',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/magnolia_pyramidata/magnolia_pyramidata.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Magnolia fraseri, commonly known as Fraser magnolia, mountain magnolia, earleaf cucumbertree, or mountain-oread, is a species of magnolia native to the south-eastern United States in the southern Appalachian Mountains and adjacent Atlantic and Gulf Coastal Plain from West Virginia south to northern Florida and west to eastern Texas.  The Appalachian plants are classified as Magnolia fraseri var. fraseri, and the more coastal plants as M. fraseri var. pyramidata.  These two kinds of magnolia are often recognized as distinct species, M. fraseri and M. pyramidata, respectively.\nFraser magnolia is a small, deciduous tree growing to 14 m (40 ft) tall, as a basal-branching, fragrant plant, with brown bark with a "warty" or "scaly" texture. The leaves are quite large, 15–25 cm (rarely up to 53 cm) long and 8–18 cm (rarely up to 29 cm) broad, with a pair of auricles (or "ear-lobes") at the base and an entire margin; they are green above and glaucous blue-green below. The showy white flowers are 16–25 cm in diameter with nine tepals; they open in late spring or early summer, after the foliage. The fruit is a woody, oblong, cone-like structure (like all Magnolias) 6.5–12 cm long, covered in small, pod-like follicles each containing one or two red seeds that hang out from the cone by a slender thread when ripe. A good seed crop occurs only about every 4–5 years. Reproduction is accomplished by both seed and vegetative sprouts. The fruit is eaten by wildlife, helping disperse the seeds.\nThis tree grows best on rich, moist, well-drained soil. The very large showy white flowers and large-leaved, coarse-textured foliage make this an attractive ornamental tree, but otherwise it has little commercial value. It is sometimes cultivated in North America as a native alternative to exotic magnolias, and can be grown a considerable distance north of its natural range if given conditions favorable to its growth.\nThere are two varieties:\n\nMagnolia fraseri var. fraseri, native to the Appalachian Mountains.\nMagnolia fraseri var. pyramidata (Bartram) Pampanini, from the Coastal Plain. The vernacular name for this variety is Pyramid magnolia.The bigleaf magnolia (Magnolia macrophylla) also has auriculate-lobed leaves.\nFraser Magnolia is named for the Scottish botanist John Fraser (1750–1811), who collected extensively in the Appalachian Mountains.',
        Longitude: -87.302205,
        Latitude: 31.99033,
      },
      geometry: { type: 'Point', coordinates: [-87.302205, 31.99033] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'MAGNOLIA',
        subspecies: ' Southern',
        scientific_name: 'Magnolia grandiflora',
        year_named: 2020.0,
        circumference_in: 208.0,
        height_in: 84.0,
        spread_ft: 64.0,
        total_points: 308.0,
        county: 'Baldwin',
        year_remeasured: 2025,
        owner: 'Pat Kennon',
        nominator: 'Patrick Waldrop',
        sci_lc: 'magnolia grandiflora',
        file_id: 4794.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/field/magnolia_grandiflora/1249580214_0000.jpg?raw=true',
        segmented_path:
          'dataset/segmented/field/magnolia_grandiflora/1249580214_0000.png',
        species_y: 'Magnolia grandiflora',
        source: 'field',
        wiki_summary:
          'Magnolia grandiflora, commonly known as the southern magnolia or bull bay, is a tree of the family Magnoliaceae native to the southeastern United States, from Virginia to central Florida, and west to East Texas. Reaching 27.5 m (90 ft) in height, it is a large, striking evergreen tree, with large dark green leaves up to 20 cm (7 3⁄4 in) long and 12 cm (4 3⁄4 in) wide, and large, white, fragrant flowers up to 30 cm (12 in) in diameter.\nAlthough endemic to the evergreen lowland subtropical forests on the Gulf and south Atlantic coastal plain, Magnolia grandiflora is widely cultivated in warmer areas around the world. The timber is hard and heavy, and has been used commercially to make furniture, pallets, and veneer.',
        Longitude: -87.746067,
        Latitude: 30.659218,
      },
      geometry: { type: 'Point', coordinates: [-87.746067, 30.659218] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'MAGNOLIA',
        subspecies: ' Sweetbay',
        scientific_name: 'Magnolia virginiana',
        year_named: 2010.0,
        circumference_in: 138.0,
        height_in: 98.0,
        spread_ft: 53.0,
        total_points: 249.0,
        county: 'Baldwin',
        year_remeasured: 2021,
        owner: 'Historic Blakeley State Park',
        nominator: 'Tad M. Zebryk',
        sci_lc: 'magnolia virginiana',
        file_id: 64041.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/magnolia_virginiana/wb1199-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/magnolia_virginiana/wb1199-01-1.png',
        species_y: 'Magnolia virginiana',
        source: 'lab',
        wiki_summary:
          'Magnolia virginiana, most commonly known as sweetbay magnolia, or merely sweetbay (also laurel magnolia, swampbay, swamp magnolia, whitebay, or beaver tree), is a member of the magnolia family, Magnoliaceae. It was the first magnolia to be scientifically described under modern rules of botanical nomenclature, and is the type species of the genus Magnolia; as Magnolia is also the type genus of all flowering plants (magnoliophytes), this species in a sense typifies all flowering plants.\n\n',
        Longitude: -87.746067,
        Latitude: 30.659218,
      },
      geometry: { type: 'Point', coordinates: [-87.746067, 30.659218] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'MAGNOLIA',
        subspecies: ' Umbrella',
        scientific_name: 'Magnolia tripetala',
        year_named: 2011.0,
        circumference_in: 27.0,
        height_in: 45.0,
        spread_ft: 20.0,
        total_points: 77.0,
        county: 'Calhoun',
        year_remeasured: 2016,
        owner: 'U. S. Forest Service',
        nominator: 'Jason Shelton',
        sci_lc: 'magnolia tripetala',
        file_id: 63820.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/magnolia_tripetala/wb1616-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/magnolia_tripetala/wb1616-01-1.png',
        species_y: 'Magnolia tripetala',
        source: 'lab',
        wiki_summary:
          'Magnolia tripetala, commonly called umbrella magnolia or simply umbrella-tree,  is a deciduous tree native to the eastern United States in the Appalachian Mountains, the Ozarks, and the Ouachita Mountains.  The name "umbrella tree" derives from the fact that the large leaves are clustered at the tips of the branches forming an umbrella-shaped structure.',
        Longitude: -85.822513,
        Latitude: 33.771706,
      },
      geometry: { type: 'Point', coordinates: [-85.822513, 33.771706] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'MAPLE',
        subspecies: ' Ash-leaf',
        scientific_name: 'Acer negundo',
        year_named: 2020.0,
        circumference_in: 121.0,
        height_in: 65.0,
        spread_ft: 68.0,
        total_points: 203.0,
        county: 'Walker',
        year_remeasured: 2025,
        owner: 'Bill Tucker',
        nominator: 'Bill Tucker',
        sci_lc: 'acer negundo',
        file_id: 69600.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/acer_negundo/pi2025-01-1.jpg?raw=true',
        segmented_path: 'dataset/segmented/lab/acer_negundo/pi2025-01-1.png',
        species_y: 'Acer negundo',
        source: 'lab',
        wiki_summary:
          'Acer negundo, the box elder, boxelder maple, Manitoba maple or ash-leaved maple, is a species of maple native to North America. It is a fast-growing, short-lived tree with opposite, compound leaves. It is sometimes considered a weedy or invasive species, and has been introduced to and naturalized throughout much of the world, including in South America, Australia, New Zealand, South Africa, much of Europe, and parts of Asia.',
        Longitude: -87.301092,
        Latitude: 33.791571,
      },
      geometry: { type: 'Point', coordinates: [-87.301092, 33.791571] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'MAPLE',
        subspecies: ' Chalk',
        scientific_name: 'Acer leucoderme',
        year_named: 2008.0,
        circumference_in: 42.0,
        height_in: 44.0,
        spread_ft: 35.0,
        total_points: 95.0,
        county: 'Wilcox',
        year_remeasured: 2018,
        owner: 'Tommy & Jeanell Lawler',
        nominator: 'Wayne Webb',
        sci_lc: 'acer leucoderme',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/acer_leucoderme/acer_leucoderme.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Acer leucoderme (English: chalk maple; also whitebark maple, pale-bark maple and sugar maple) is a deciduous tree native to the southeastern United States from North Carolina south to northwest Florida and west to eastern Texas. It lives in the understory in moist, rocky soils on river banks, ravines, woods, and cliffs. Although generally a uncommon tree, it is most often found in the inner coastal plain and Piedmont regions of Georgia.',
        Longitude: -87.302205,
        Latitude: 31.99033,
      },
      geometry: { type: 'Point', coordinates: [-87.302205, 31.99033] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'MAPLE',
        subspecies: ' Florida',
        scientific_name: 'Acer floridanum',
        year_named: 2010.0,
        circumference_in: 81.0,
        height_in: 85.0,
        spread_ft: 31.0,
        total_points: 174.0,
        county: 'Lowndes',
        year_remeasured: 2020,
        owner: 'Resource Mgmt. Service',
        nominator: 'Wayne Webb',
        sci_lc: 'acer barbatum',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/acer_floridanum/acer_floridanum.JPG?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Acer saccharum, the sugar maple, is a species of flowering plant in the soapberry and lychee family Sapindaceae. It is native to the hardwood forests of eastern Canada, from Nova Scotia west through southern Quebec, central and southern Ontario to southeastern Manitoba around Lake of the Woods, and northcentral and northeastern United States, from Minnesota  eastward to Maine and southward to northern Virginia, Tennessee and Missouri. Sugar maple is best known for being the primary source of maple syrup and for its brightly colored fall foliage. It may also be known as "rock maple", "sugar tree", "birds-eye maple", "sweet maple", "curly maple", or "hard maple", particularly when referring to the wood.',
        Longitude: -86.650586,
        Latitude: 32.147888,
      },
      geometry: { type: 'Point', coordinates: [-86.650586, 32.147888] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'MAPLE',
        subspecies: ' Red',
        scientific_name: 'Acer rubrum',
        year_named: 2017.0,
        circumference_in: 136.0,
        height_in: 97.0,
        spread_ft: 52.0,
        total_points: 246.0,
        county: 'Perry',
        year_remeasured: 2022,
        owner: 'Joe Mathis Jr.',
        nominator: 'Joe Mathis Jr.',
        sci_lc: 'acer rubrum',
        file_id: 57299.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/acer_rubrum/pi2388-01-1.jpg?raw=true',
        segmented_path: 'dataset/segmented/lab/acer_rubrum/pi2388-01-1.png',
        species_y: 'Acer rubrum',
        source: 'lab',
        wiki_summary:
          'Acer rubrum, the red maple, also known as swamp, water or soft maple, is one of the most common and widespread deciduous trees of eastern and central North America. The U.S. Forest service recognizes it as the most abundant native tree in eastern North America. The red maple ranges from southeastern Manitoba around the Lake of the Woods on the border with Ontario and Minnesota, east to Newfoundland, south to Florida, and southwest to East Texas. Many of its features, especially its leaves, are quite variable in form. At maturity, it often attains a height of around 30 m (100 ft). Its flowers, petioles, twigs and seeds are all red to varying degrees. Among these features, however, it is best known for its brilliant deep scarlet foliage in autumn.\nOver most of its range, red maple is adaptable to a very wide range of site conditions, perhaps more so than any other tree in eastern North America. It can be found growing in swamps, on poor dry soils, and almost anywhere in between. It grows well from sea level to about 900 m (3,000 ft). Due to its attractive fall foliage and pleasing form, it is often used as a shade tree for landscapes. It is used commercially on a small scale for maple syrup production as well as for its medium to high quality lumber. It is also the state tree of Rhode Island. The red maple can be considered weedy or even invasive in young, highly disturbed forests, especially frequently logged forests. In a mature or old growth northern hardwood forest, red maple only has a sparse presence, while shade tolerant trees such as sugar maples, beeches, and hemlocks thrive. By removing red maple from a young forest recovering from disturbance, the natural cycle of forest regeneration is altered, changing the diversity of the forest for centuries to come.',
        Longitude: -87.293827,
        Latitude: 32.639005,
      },
      geometry: { type: 'Point', coordinates: [-87.293827, 32.639005] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'MAPLE',
        subspecies: ' Silver',
        scientific_name: 'Acer saccharinum',
        year_named: 2013.0,
        circumference_in: 103.0,
        height_in: 84.0,
        spread_ft: 68.0,
        total_points: 204.0,
        county: 'Jackson',
        year_remeasured: 2018,
        owner: 'Ron & Dianne Lee',
        nominator: 'Adam Ziegenbein & Josh Angel',
        sci_lc: 'acer saccharinum',
        file_id: 57316.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/acer_saccharinum/pi0066-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/acer_saccharinum/pi0066-01-1.png',
        species_y: 'Acer saccharinum',
        source: 'lab',
        wiki_summary:
          'Acer saccharinum, commonly known as silver maple, creek maple, silverleaf maple, soft maple, large maple, water maple, swamp maple, or white maple, is a species of maple native to the eastern and central United States and southeastern Canada. It is one of the most common trees in the United States.\nAlthough the silver maple‘s Latin name is similar, it should not be confused with Acer saccharum, the sugar maple. Some of the common names are also applied to other maples, especially Acer rubrum.\n\n',
        Longitude: -85.9774,
        Latitude: 34.763522,
      },
      geometry: { type: 'Point', coordinates: [-85.9774, 34.763522] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'MAPLE',
        subspecies: ' Sugar',
        scientific_name: 'Acer saccharum',
        year_named: 2016.0,
        circumference_in: 96.0,
        height_in: 80.0,
        spread_ft: 64.0,
        total_points: 192.0,
        county: 'Madison',
        year_remeasured: 2021,
        owner: 'Susan Weber',
        nominator: 'Susan Weber',
        sci_lc: 'acer saccharum',
        file_id: 4396.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/field/acer_saccharum/1248106746_0000.jpg?raw=true',
        segmented_path:
          'dataset/segmented/field/acer_saccharum/1248106746_0000.png',
        species_y: 'Acer saccharum',
        source: 'field',
        wiki_summary:
          'Acer saccharum, the sugar maple, is a species of flowering plant in the soapberry and lychee family Sapindaceae. It is native to the hardwood forests of eastern Canada, from Nova Scotia west through southern Quebec, central and southern Ontario to southeastern Manitoba around Lake of the Woods, and northcentral and northeastern United States, from Minnesota  eastward to Maine and southward to northern Virginia, Tennessee and Missouri. Sugar maple is best known for being the primary source of maple syrup and for its brightly colored fall foliage. It may also be known as "rock maple", "sugar tree", "birds-eye maple", "sweet maple", "curly maple", or "hard maple", particularly when referring to the wood.',
        Longitude: -86.55108,
        Latitude: 34.764238,
      },
      geometry: { type: 'Point', coordinates: [-86.55108, 34.764238] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'MAYHAW',
        subspecies: 'N/A',
        scientific_name: 'Crataegus aestivalis',
        year_named: 2007.0,
        circumference_in: 20.0,
        height_in: 20.0,
        spread_ft: 22.0,
        total_points: 46.0,
        county: 'Baldwin',
        year_remeasured: 2017,
        owner: 'F.E. Little',
        nominator: 'Jason Shelton',
        sci_lc: 'crataegus aestivalis',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/crataegus_aestivalis/crataegus_aestivalis.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Crataegus aestivalis, known as the eastern mayhaw, is a shrub or small tree of the southeastern United States that grows in low-lying or wet areas from eastern Alabama to central Florida and Virginia.  It is one of several species of hawthorn with fruits known as "mayhaws", which are harvested for use in making mayhaw jelly, considered a delicacy in many areas of the South. Other species of mayhaws include Crataegus opaca, the western May Hawthorn, which is native from east Texas to Alabama.\nThe jelly is a rosy color, with a delicate flavor. It\'s sometimes commercially available at farm stands or specialty Southern food stores.',
        Longitude: -87.746067,
        Latitude: 30.659218,
      },
      geometry: { type: 'Point', coordinates: [-87.746067, 30.659218] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'MULBERRY',
        subspecies: ' Red',
        scientific_name: 'Morus rubra',
        year_named: 2009.0,
        circumference_in: 256.0,
        height_in: 55.0,
        spread_ft: 51.0,
        total_points: 324.0,
        county: 'Choctaw',
        year_remeasured: 2019,
        owner: 'William J. Scruggs',
        nominator: 'Lorenzo Johnson',
        sci_lc: 'morus rubra',
        file_id: 4789.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/field/morus_rubra/1249580175_0000.jpg?raw=true',
        segmented_path:
          'dataset/segmented/field/morus_rubra/1249580175_0000.png',
        species_y: 'Morus rubra',
        source: 'field',
        wiki_summary:
          'Morus rubra, commonly known as the red mulberry, is a species of mulberry native to eastern and central North America. It is found from Ontario, Minnesota, and Vermont south to southern Florida, and west as far as southeastern South Dakota, Nebraska, Kansas, and central Texas. There have been reports of isolated populations (very likely naturalized) in New Mexico, Idaho, and British Columbia.Common in the United States, it is listed as an endangered species in Canada, and is susceptible to hybridization with the invasive white mulberry (M. alba), introduced from Asia.\n\n',
        Longitude: -88.248887,
        Latitude: 31.991008,
      },
      geometry: { type: 'Point', coordinates: [-88.248887, 31.991008] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Arkansas',
        scientific_name: 'Quercus arkansana',
        year_named: 1991.0,
        circumference_in: 45.0,
        height_in: 49.0,
        spread_ft: 30.0,
        total_points: 102.0,
        county: 'Autauga',
        year_remeasured: 2018,
        owner: 'John C. Pirtle',
        nominator: 'Tom Lang',
        sci_lc: 'quercus arkansana',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/quercus_arkansana/quercus_arkansana.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Quercus arkansana, the Arkansas oak, is a species of tree in the beech family. It is native to the southeastern United States (eastern Texas, southern Arkansas, Louisiana, Mississippi, Alabama, Georgia, and the Florida Panhandle). It is threatened by use of its habitat for pine plantations, clearing of land, and diebacks that may be caused by drought.',
        Longitude: -86.64449,
        Latitude: 32.536382,
      },
      geometry: { type: 'Point', coordinates: [-86.64449, 32.536382] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Black',
        scientific_name: 'Quercus velutina',
        year_named: 2017.0,
        circumference_in: 213.0,
        height_in: 114.0,
        spread_ft: 127.0,
        total_points: 359.0,
        county: 'Morgan',
        year_remeasured: 2022,
        owner: 'Mr. and Mrs. Chris Gilliand',
        nominator: 'Mr. and Mrs. Chris Gilliand',
        sci_lc: 'quercus velutina',
        file_id: 72561.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/quercus_velutina/wb1445-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/quercus_velutina/wb1445-01-1.png',
        species_y: 'Quercus velutina',
        source: 'lab',
        wiki_summary:
          'Quercus velutina, the black oak, is a species of oak in the red oak group (Quercus sect. Lobatae), native and widespread in eastern and central North America. It is found in all the coastal states from Maine to Texas, inland as far as Michigan, Ontario, Minnesota, Nebraska, Kansas, Oklahoma, and eastern Texas. It is sometimes called the eastern black oak.Quercus velutina was previously known as yellow oak due to the yellow pigment in its inner bark, however nowadays this name is usually reserved for chinkapin oak. It is a close relative of the California black oak (Quercus kelloggii) found in western North America.',
        Longitude: -86.846402,
        Latitude: 34.454484,
      },
      geometry: { type: 'Point', coordinates: [-86.846402, 34.454484] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Black',
        scientific_name: 'Quercus velutina',
        year_named: 2017.0,
        circumference_in: 220.0,
        height_in: 112.0,
        spread_ft: 102.0,
        total_points: 358.0,
        county: 'Bullock',
        year_remeasured: 2022,
        owner: 'David Allen',
        nominator: 'David Allen',
        sci_lc: 'quercus velutina',
        file_id: 72561.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/quercus_velutina/wb1445-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/quercus_velutina/wb1445-01-1.png',
        species_y: 'Quercus velutina',
        source: 'lab',
        wiki_summary:
          'Quercus velutina, the black oak, is a species of oak in the red oak group (Quercus sect. Lobatae), native and widespread in eastern and central North America. It is found in all the coastal states from Maine to Texas, inland as far as Michigan, Ontario, Minnesota, Nebraska, Kansas, Oklahoma, and eastern Texas. It is sometimes called the eastern black oak.Quercus velutina was previously known as yellow oak due to the yellow pigment in its inner bark, however nowadays this name is usually reserved for chinkapin oak. It is a close relative of the California black oak (Quercus kelloggii) found in western North America.',
        Longitude: -85.717261,
        Latitude: 32.101759,
      },
      geometry: { type: 'Point', coordinates: [-85.717261, 32.101759] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Blackjack',
        scientific_name: 'Quercus marilandica',
        year_named: 2020.0,
        circumference_in: 105.0,
        height_in: 84.0,
        spread_ft: 84.0,
        total_points: 210.0,
        county: 'Walker',
        year_remeasured: 2025,
        owner: 'Louis Hall',
        nominator: 'Chris Wright',
        sci_lc: 'quercus marilandica',
        file_id: 71085.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/quercus_marilandica/wb1244-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/quercus_marilandica/wb1244-01-1.png',
        species_y: 'Quercus marilandica',
        source: 'lab',
        wiki_summary:
          'Quercus marilandica, the blackjack oak, is a small oak, one of the red oak group Quercus sect. Lobatae. It is native to the eastern and central United States, from Long Island to Florida, west as far as Texas, Oklahoma, and Nebraska. There are reports of a few isolated populations in southern Michigan, but these appear to represent introductions.\n\nQuercus marilandica is a small deciduous tree growing to 15 meters (49 feet) tall, with bark cracked into rectangular black plates with narrow orange fissures. The leaves are 7–20 cm (3–8 in) long and broad, and typically flare from a tapered base to a broad three-lobed bell shape with only shallow indentations. They are dark green and glossy above, pubescent underneath, and often remain attached to the twigs through the winter after turning colors from red to brown in the fall. The acorn is small, 12–20 mm (0.47–0.79 in) long and 10–18 mm (0.39–0.71 in) broad; like other red oaks, it takes 18 months to mature.',
        Longitude: -87.301092,
        Latitude: 33.791571,
      },
      geometry: { type: 'Point', coordinates: [-87.301092, 33.791571] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Bluff',
        scientific_name: 'Quercus austrina',
        year_named: 2000.0,
        circumference_in: 102.0,
        height_in: 101.0,
        spread_ft: 52.0,
        total_points: 216.0,
        county: 'Baldwin',
        year_remeasured: 2017,
        owner: 'City of Daphne',
        nominator: 'Dr. Harry Larsen & Fred Nation',
        sci_lc: 'quercus austrina',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/quercus_austrina/quercus_austrina.png?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Quercus austrina, the bastard white oak or bluff oak, is an oak species that is endemic to the southeastern United States from Mississippi to the Carolinas, with a few isolated populations in Arkansas.Quercus austrina can grow to a height of 45 to 60 feet (13.5-18.0 meters) with a spread of 35 to 50 feet (10.5-15.0 meters). Leaves are narrow, with shallow rounded lobes. It tends to grow in wet habitats, such as on river bluffs, river bottoms, and flatwoods, and generally over basic substrates, such as mafic rocks, shells, or calcareous sediment.Quercus austrina specimens have often been misidentified as either Q. sinuata or Q. nigra.Quercus austrina is tolerant to clay, sand, loam, acidic, and well-drained soils. Also, it requires a lot of sun and its drought tolerance is high.',
        Longitude: -87.746067,
        Latitude: 30.659218,
      },
      geometry: { type: 'Point', coordinates: [-87.746067, 30.659218] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Bur',
        scientific_name: 'Quercus macrocarpa',
        year_named: 1990.0,
        circumference_in: 116.0,
        height_in: 59.0,
        spread_ft: 75.0,
        total_points: 194.0,
        county: 'Montgomery',
        year_remeasured: 2017,
        owner: 'Huntingdon College',
        nominator: 'Dr. Douglas T. McGinty',
        sci_lc: 'quercus macrocarpa',
        file_id: 70840.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/quercus_macrocarpa/wb1133-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/quercus_macrocarpa/wb1133-01-1.png',
        species_y: 'Quercus macrocarpa',
        source: 'lab',
        wiki_summary:
          'Quercus macrocarpa, the bur oak, commonly spelled burr oak, is a species of oak tree native to eastern North America. It is in the white oak section, Quercus sect. Quercus, and is also called mossycup oak, mossycup white oak, blue oak, or scrub oak. The acorns are the largest of any North American oak (thus the species name macrocarpa, from Ancient Greek μακρός makrós "large" and καρπός karpós "fruit"), and are important food for wildlife.\n\n',
        Longitude: -86.203831,
        Latitude: 32.203651,
      },
      geometry: { type: 'Point', coordinates: [-86.203831, 32.203651] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Cherrybark',
        scientific_name: 'Quercus pagoda',
        year_named: 2020.0,
        circumference_in: 240.0,
        height_in: 156.0,
        spread_ft: 131.0,
        total_points: 429.0,
        county: 'Wilcox',
        year_remeasured: 2025,
        owner: 'W.R Phillippi.',
        nominator: 'Ben Etheridge',
        sci_lc: 'quercus pagoda',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/quercus_pagoda/quercus_pagoda.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Quercus pagoda, the cherrybark oak, is one of the most highly valued red oaks in the southern United States. It is larger and better formed than southern red oak and commonly grows on more moist sites.  Its strong wood and straight form make it an excellent timber tree.  Many wildlife species use its acorns as food, and cherrybark oak makes a fine shade tree.  Cherrybark oak was formerly considered to be a subspecies of southern red oak, Quercus falcata, subsp pagodifolia.',
        Longitude: -87.302205,
        Latitude: 31.99033,
      },
      geometry: { type: 'Point', coordinates: [-87.302205, 31.99033] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'OAK',
        subspecies: ' Chestnut',
        scientific_name: 'Quercus prinus',
        year_named: 2014.0,
        circumference_in: 142.0,
        height_in: 80.0,
        spread_ft: 73.0,
        total_points: 240.0,
        county: 'Clay',
        year_remeasured: 2019,
        owner: 'Lamar Dewberry',
        nominator: 'Nick Jordan',
        sci_lc: 'quercus prinus',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/quercus_prinus/quercus_prinus.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Quercus montana, the chestnut oak, is a species of oak in the white oak group, Quercus sect. Quercus. It is native to the eastern United States, where it is one of the most important ridgetop trees from southern Maine southwest to central Mississippi, with an outlying northwestern population in southern Michigan. It is also sometimes called rock oak because of its presence in montane and other rocky habitats. As a consequence of its dry habitat and ridgetop exposure, it is not usually a large tree, typically 18–22 m (59–72 ft) tall; occasional specimens growing in better conditions can however become large, with trees up to 40–43 m (131–141 ft) tall known. They tend to have a similar spread of 18–22 m (59–72 ft). A 10-year-old sapling grown in full sun will stand about 5 m (16 ft) tall. This species is often an important canopy species in an oak-heath forest.',
        Longitude: -85.862051,
        Latitude: 33.267809,
      },
      geometry: { type: 'Point', coordinates: [-85.862051, 33.267809] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'HEMLOCK',
        subspecies: ' Eastern',
        scientific_name: 'Tsuga canadensis',
        year_named: 1992.0,
        circumference_in: 155.0,
        height_in: 118.0,
        spread_ft: 35.0,
        total_points: 282.0,
        county: 'Winston',
        year_remeasured: 2017,
        owner: 'U. S. Forest Service',
        nominator: 'Robert Taylor',
        sci_lc: 'tsuga canadensis',
        file_id: 74633.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/tsuga_canadensis/wb1085-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/tsuga_canadensis/wb1085-01-1.png',
        species_y: 'Tsuga canadensis',
        source: 'lab',
        wiki_summary:
          'Tsuga canadensis, also known as eastern hemlock, eastern hemlock-spruce, or Canadian hemlock, and in the French-speaking regions of Canada as pruche du Canada, is a coniferous tree native to eastern North America. It is the state tree of Pennsylvania.',
        Longitude: -87.364147,
        Latitude: 34.155888,
      },
      geometry: { type: 'Point', coordinates: [-87.364147, 34.155888] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'HERCULES’ CLUB',
        subspecies: 'N/A',
        scientific_name: 'Zanthoxylum clava-herculis',
        year_named: 2005.0,
        circumference_in: 33.0,
        height_in: 61.0,
        spread_ft: 26.0,
        total_points: 101.0,
        county: 'Baldwin',
        year_remeasured: 2019,
        owner: 'Blakeley State Park',
        nominator: 'Dr. Harry Larsen & Fred Nation',
        sci_lc: 'zanthoxylum clava-herculis',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/zanthoxylum_clava-herculis/zanthoxylum_clava-herculis.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Zanthoxylum clava-herculis, the Hercules\' club, Hercules-club, pepperwood, or southern prickly ash, is a spiny tree or shrub native to the southeastern United States. It grows to 10–17 m tall and has distinctive spined thick, corky lumps 2–3 cm long on the bark. The leaves are glabrous and leathery,\npinnately compound, 20–30 cm long with 7-19 leaflets, each leaflet 4–5 cm long. The flowers are dioecious, in panicles up to 20 cm long, each flower small, 6–8 mm diameter, with 3-5 white petals. The fruit is a two-valved capsule 6 mm diameter with a rough surface, and containing several small black seeds.  The tree has also been called Z. macrophyllum.  The genus name is sometimes spelled Xanthoxylum.\n\nAlong with the related Zanthoxylum americanum, it is sometimes called "toothache tree" or "tingle tongue" because chewing on the leaves, bark, or twigs causes a tingling numbness of the mouth, tongue, teeth and gums. It was used for such medicinal purposes by both Native Americans and early settlers to treat toothache because of this.The tree has a rounded crown and requires plentiful water and sunlight. Its leaves are browsed by deer and its fruit is eaten by birds.\nThe fruit passes through birds, which helps the seeds to germinate.\nThe new trees tend to\nsprout below the favorite resting places of the birds, along fence rows and the edge of woods.\nIt is known to be host to a number of insect species, including the Giant Swallowtail (Papilio cresphontes) and the leaf beetle Derospidea brevicollis.',
        Longitude: -87.746067,
        Latitude: 30.659218,
      },
      geometry: { type: 'Point', coordinates: [-87.746067, 30.659218] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'HICKORY',
        subspecies: ' Bitternut',
        scientific_name: 'Carya cordiformis',
        year_named: 2011.0,
        circumference_in: 70.0,
        height_in: 82.0,
        spread_ft: 44.0,
        total_points: 163.0,
        county: 'Lauderdale',
        year_remeasured: 2021,
        owner: 'Joe Wheeler State Park',
        nominator: 'Jason Shelton',
        sci_lc: 'carya cordiformis',
        file_id: 70901.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/carya_cordiformis/pi0053-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/carya_cordiformis/pi0053-01-1.png',
        species_y: 'Carya cordiformis',
        source: 'lab',
        wiki_summary:
          'Carya cordiformis, the bitternut hickory, also called bitternut or swamp hickory, is a large pecan hickory with commercial stands located mostly north of the other pecan hickories. Bitternut hickory is cut and sold in mixture with the true hickories. It is the shortest-lived of the hickories, living to about 200 years.',
        Longitude: -87.650997,
        Latitude: 34.904122,
      },
      geometry: { type: 'Point', coordinates: [-87.650997, 34.904122] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'HICKORY',
        subspecies: ' Carolina',
        scientific_name: 'Carya carolinae-septentrionalis',
        year_named: 2014.0,
        circumference_in: 94.0,
        height_in: 136.0,
        spread_ft: 69.0,
        total_points: 247.0,
        county: 'Wilcox',
        year_remeasured: 2019,
        owner: 'Tommy & Jeanell Lawler',
        nominator: 'Wayne Webb',
        sci_lc: 'carya carolinae-septentrionalis',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/carya_carolinae-septentrionalis/carya_carolinae-septentrionalis.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary: 'wikipedia page not found.',
        Longitude: -87.302205,
        Latitude: 31.99033,
      },
      geometry: { type: 'Point', coordinates: [-87.302205, 31.99033] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'HICKORY',
        subspecies: ' Mockernut',
        scientific_name: 'Carya tomentosa',
        year_named: 2014.0,
        circumference_in: 103.0,
        height_in: 114.0,
        spread_ft: 62.0,
        total_points: 233.0,
        county: 'Coosa',
        year_remeasured: 2019,
        owner: 'John T. Goff Family LLC',
        nominator: 'John Goff',
        sci_lc: 'carya tomentosa',
        file_id: 56964.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/carya_tomentosa/wb1091-01-1.jpg?raw=true',
        segmented_path: 'dataset/segmented/lab/carya_tomentosa/wb1091-01-1.png',
        species_y: 'Carya tomentosa',
        source: 'lab',
        wiki_summary:
          'Carya tomentosa, (mockernut hickory, mockernut, white hickory, whiteheart hickory, hognut, bullnut) is a tree in the Juglandaceae or walnut family. The most abundant of the hickories, common in the eastern half of the US, it is long lived, sometimes reaching the age of 500 years. A straight-growing hickory, a high percentage of its wood is used for products where strength, hardness, and flexibility are needed. The wood makes excellent fuel wood, as well. The leaves turn yellow in Autumn.\nThe species\' name comes from the Latin word tomentum, meaning "covered with dense, short hairs," referring to the underside of the leaves, which help identify the species. Also called the white hickory due to the light color of the wood, the common name mockernut comes from the large, thick-shelled fruit with very small kernels of meat inside.',
        Longitude: -86.243482,
        Latitude: 32.931445,
      },
      geometry: { type: 'Point', coordinates: [-86.243482, 32.931445] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'HICKORY',
        subspecies: ' Nutmeg',
        scientific_name: 'Carya myristiciformis',
        year_named: 2009.0,
        circumference_in: 73.0,
        height_in: 84.0,
        spread_ft: 43.0,
        total_points: 168.0,
        county: 'Dallas',
        year_remeasured: 2019,
        owner: 'James Shand',
        nominator: 'Dr. Thomas H. Wilson',
        sci_lc: 'carya myristiciformis',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/carya_myristiciformis/carya_myristiciformis.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Carya myristiciformis, the nutmeg hickory, of the Juglandaceae or walnut family, also called swamp hickory or bitter water hickory, is found as small, possibly relict populations across the Southern United States and in northern Mexico on rich moist soils of higher bottom lands and stream banks. Little is known of the growth rate of nutmeg hickory. Logs and lumber are sold mixed with other hickories. The nuts are an oil-rich food for wildlife.',
        Longitude: -87.114356,
        Latitude: 32.33354,
      },
      geometry: { type: 'Point', coordinates: [-87.114356, 32.33354] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'HICKORY',
        subspecies: ' Pignut',
        scientific_name: 'Carya glabra',
        year_named: 2020.0,
        circumference_in: 119.0,
        height_in: 100.0,
        spread_ft: 70.0,
        total_points: 236.0,
        county: 'Randolph',
        year_remeasured: 2025,
        owner: 'Bonnie Sue Knight',
        nominator: 'Gerry Knight- N',
        sci_lc: 'carya glabra',
        file_id: 56513.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/carya_glabra/pi0046-01-1.jpg?raw=true',
        segmented_path: 'dataset/segmented/lab/carya_glabra/pi0046-01-1.png',
        species_y: 'Carya glabra',
        source: 'lab',
        wiki_summary:
          'Carya glabra, the pignut hickory, is a common, but not abundant species of hickory in the oak-hickory forest association in the Eastern United States and Canada. Other common names are pignut, sweet pignut, coast pignut hickory, smoothbark hickory, swamp hickory, and broom hickory. The pear-shaped nut ripens in September and October, has a sweet maple like smell, and is an important part of the diet of many wild animals. The wood is used for a variety of products, including fuel for home heating. Its leaves turn yellow in the Fall.\n\n',
        Longitude: -85.464068,
        Latitude: 33.296475,
      },
      geometry: { type: 'Point', coordinates: [-85.464068, 33.296475] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'HICKORY',
        subspecies: ' Red',
        scientific_name: 'Carya ovalis',
        year_named: 2015.0,
        circumference_in: 128.0,
        height_in: 115.0,
        spread_ft: 69.0,
        total_points: 260.0,
        county: 'Butler',
        year_remeasured: 2020,
        owner: 'State of Alabama',
        nominator: 'Wayne K. Webb',
        sci_lc: 'carya ovalis',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/carya_ovalis/carya_ovalis.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Carya ovalis, the red hickory or sweet pignut hickory, is a fairly uncommon but widespread hickory native to eastern North America. It is typically found growing in dry, well drained sandy upland ridges and sloped woodlands from southern Ontario, Canada, and in the United States east to New Hampshire, south to northern Florida west to eastern Texas and north-west to Nebraska. This species was formerly treated as a variety or northern ecotype of the pignut hickory C. glabra, described as Carya glabra var. odorata. This discrepancy has not yet been completely resolved, and some sources and authors still consider red hickory as a variety or synonym of pignut hickory. However both trees are quite morphologically distinct.',
        Longitude: -86.681969,
        Latitude: 31.751667,
      },
      geometry: { type: 'Point', coordinates: [-86.681969, 31.751667] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'HICKORY',
        subspecies: ' Sand',
        scientific_name: 'Carya pallida',
        year_named: 2011.0,
        circumference_in: 88.0,
        height_in: 82.0,
        spread_ft: 23.0,
        total_points: 178.0,
        county: 'Cherokee',
        year_remeasured: 2021,
        owner: 'Cherokee Co. Parks & Rec Board O',
        nominator: 'Jason Shelton',
        sci_lc: 'carya pallida',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/carya_pallida/carya_pallida.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Carya pallida, sand hickory, or pale hickory is a species of hickory native to the southeastern United States. It is a perennial, dichotomous plant which prefers rocky or sandy habitats. The sand hickory can reach heights of up to 30m, but its typical height is between 9-24m. In an open area, Carya crowns are usually towering and slim. The sand hickory nut is edible and consumed by various organisms.',
        Longitude: -85.654242,
        Latitude: 34.069515,
      },
      geometry: { type: 'Point', coordinates: [-85.654242, 34.069515] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'HICKORY',
        subspecies: ' Shagbark',
        scientific_name: 'Carya ovata',
        year_named: 2014.0,
        circumference_in: 94.0,
        height_in: 126.0,
        spread_ft: 59.0,
        total_points: 235.0,
        county: 'Blount',
        year_remeasured: 2019,
        owner: 'Charles & Jamie LeCroy',
        nominator: 'Charles LeCroy',
        sci_lc: 'carya ovata',
        file_id: 56832.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/carya_ovata/wb1076-01-1.jpg?raw=true',
        segmented_path: 'dataset/segmented/lab/carya_ovata/wb1076-01-1.png',
        species_y: 'Carya ovata',
        source: 'lab',
        wiki_summary:
          "Carya ovata, the shagbark hickory, is a common hickory in the Eastern United States and southeast Canada. It is a large, deciduous tree, growing well over  100 ft (30 m) tall, and can live more than 350 years. The tallest measured shagbark, located in Savage Gulf, Tennessee, is over 150 ft (46 m) tall.  Mature shagbarks are easy to recognize because, as their name implies, they have shaggy bark. This characteristic is, however, only found on mature trees; young specimens have smooth bark.\nThe shagbark hickory's nut is edible and has a very sweet taste.\nThe leaves are 30–60 cm (12–24 in) long, pinnate, with five (rarely three or seven) leaflets, the terminal three leaflets much larger than the basal pair. The shagbark hickory is monoecious. Staminate flowers are borne on long-stalked catkins at the tip of old wood or in the axils of the previous season's leaves.  Pistillate flowers occur in short terminal spikes. The fruit is a drupe 2.5 to 4.0 cm (1 to 1 1⁄2 in) long, an edible nut with a hard, bony shell, contained in a thick, green four-sectioned husk which turns dark and splits off at maturity in the fall. The terminal buds on the shagbark hickory are large and covered with loose scales.  Shagbark hickory nuts were a significant food source for the Algonquins. Red squirrels, gray squirrels, raccoons, chipmunks, and mice are consumers of hickory nuts. Other consumers include  black bears, gray and red foxes, rabbits, and bird species such as mallards, wood ducks, bobwhites, and wild turkey.The two varieties are:\n\nCarya ovata var. ovata (northern shagbark hickory) has its largest leaflets over 20 cm (8 in) long and nuts 3.0–4.0 cm (1 1⁄8–1 5⁄8 in) long.\nCarya ovata var. australis (southern shagbark hickory or Carolina hickory) has its largest leaflets under 20 cm (8 in) long and nuts 2.5–3.0 cm (1–1 1⁄8 in) long.Some sources regard southern shagbark hickory as the separate species Carya carolinae-septentrionalis.",
        Longitude: -86.567246,
        Latitude: 33.977448,
      },
      geometry: { type: 'Point', coordinates: [-86.567246, 33.977448] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'HICKORY',
        subspecies: ' Shagbark',
        scientific_name: 'Carya ovata',
        year_named: 2008.0,
        circumference_in: 96.0,
        height_in: 117.0,
        spread_ft: 64.0,
        total_points: 229.0,
        county: 'Etowah',
        year_remeasured: 2018,
        owner: 'Scott Morris',
        nominator: 'Scott Morris',
        sci_lc: 'carya ovata',
        file_id: 56832.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/carya_ovata/wb1076-01-1.jpg?raw=true',
        segmented_path: 'dataset/segmented/lab/carya_ovata/wb1076-01-1.png',
        species_y: 'Carya ovata',
        source: 'lab',
        wiki_summary:
          "Carya ovata, the shagbark hickory, is a common hickory in the Eastern United States and southeast Canada. It is a large, deciduous tree, growing well over  100 ft (30 m) tall, and can live more than 350 years. The tallest measured shagbark, located in Savage Gulf, Tennessee, is over 150 ft (46 m) tall.  Mature shagbarks are easy to recognize because, as their name implies, they have shaggy bark. This characteristic is, however, only found on mature trees; young specimens have smooth bark.\nThe shagbark hickory's nut is edible and has a very sweet taste.\nThe leaves are 30–60 cm (12–24 in) long, pinnate, with five (rarely three or seven) leaflets, the terminal three leaflets much larger than the basal pair. The shagbark hickory is monoecious. Staminate flowers are borne on long-stalked catkins at the tip of old wood or in the axils of the previous season's leaves.  Pistillate flowers occur in short terminal spikes. The fruit is a drupe 2.5 to 4.0 cm (1 to 1 1⁄2 in) long, an edible nut with a hard, bony shell, contained in a thick, green four-sectioned husk which turns dark and splits off at maturity in the fall. The terminal buds on the shagbark hickory are large and covered with loose scales.  Shagbark hickory nuts were a significant food source for the Algonquins. Red squirrels, gray squirrels, raccoons, chipmunks, and mice are consumers of hickory nuts. Other consumers include  black bears, gray and red foxes, rabbits, and bird species such as mallards, wood ducks, bobwhites, and wild turkey.The two varieties are:\n\nCarya ovata var. ovata (northern shagbark hickory) has its largest leaflets over 20 cm (8 in) long and nuts 3.0–4.0 cm (1 1⁄8–1 5⁄8 in) long.\nCarya ovata var. australis (southern shagbark hickory or Carolina hickory) has its largest leaflets under 20 cm (8 in) long and nuts 2.5–3.0 cm (1–1 1⁄8 in) long.Some sources regard southern shagbark hickory as the separate species Carya carolinae-septentrionalis.",
        Longitude: -86.03442,
        Latitude: 34.047638,
      },
      geometry: { type: 'Point', coordinates: [-86.03442, 34.047638] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'HICKORY',
        subspecies: ' Shellbark',
        scientific_name: 'Carya laciniosa',
        year_named: 2007.0,
        circumference_in: 102.0,
        height_in: 112.0,
        spread_ft: 90.0,
        total_points: 237.0,
        county: 'Madison',
        year_remeasured: 2017,
        owner: 'City of Huntsville Hays Nature Preserve O',
        nominator: 'Susan Weber',
        sci_lc: 'carya laciniosa',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/carya_laciniosa/carya_laciniosa.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Carya laciniosa, the shellbark hickory, in the Juglandaceae or walnut family is also called shagbark hickory, bigleaf shagbark hickory, kingnut, big, bottom, thick, or western shellbark, attesting to some of its characteristics. It is a slow-growing, long-lived tree, hard to transplant because of its long taproot, and subject to insect damage. The nuts, largest of all hickory nuts, are sweet and edible. Wildlife and people harvest most of them; those remaining produce seedling trees readily. The wood is hard, heavy, strong, and very flexible, making it a favored wood for tool handles. A specimen tree has been reported in Missouri with 117 cm (46 in) diameter at breast height, 36.9 m (121 ft 1 in) tall, and a spread of 22.6 m (74 ft 2 in).',
        Longitude: -86.55108,
        Latitude: 34.764238,
      },
      geometry: { type: 'Point', coordinates: [-86.55108, 34.764238] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'HICKORY',
        subspecies: ' Water',
        scientific_name: 'Carya aquatica',
        year_named: 2001.0,
        circumference_in: 152.0,
        height_in: 136.0,
        spread_ft: 78.0,
        total_points: 308.0,
        county: 'Baldwin',
        year_remeasured: 2016,
        owner: 'State of Alabama Forever Wild',
        nominator: 'Dr. Harry Larsen & Fred Nation',
        sci_lc: 'carya aquatica',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/carya_aquatica/carya_aquatica.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Carya aquatica, the bitter pecan or water hickory, is a large tree, that can grow over 30 metres (98 ft) tall of the Juglandaceae or walnut family. In the American South it is a dominant plant species found on clay flats and backwater areas near streams and rivers. The species reproduces aggressively both by seed and sprouts from roots and from stumps of cut trees. Water hickory is a major component of wetland forests now in the south eastern US, because of the selective cutting of more desirable tree species for the lumber industry. It is considered important in cleansing drainage waters since the plants slow water flow during flooding, allowing sediments to fall out of the water column. This tree species is tolerant of wet soils but grows best on well draining soils near rivers and other water ways.',
        Longitude: -87.746067,
        Latitude: 30.659218,
      },
      geometry: { type: 'Point', coordinates: [-87.746067, 30.659218] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'HOLLY',
        subspecies: ' American',
        scientific_name: 'Ilex opaca',
        year_named: 1987.0,
        circumference_in: 126.0,
        height_in: 55.0,
        spread_ft: 45.0,
        total_points: 192.0,
        county: 'Chambers',
        year_remeasured: 2017,
        owner: 'Norbord',
        nominator: 'Jeff Abney',
        sci_lc: 'ilex opaca',
        file_id: 4301.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/field/ilex_opaca/1248105728_0000.jpg?raw=true',
        segmented_path:
          'dataset/segmented/field/ilex_opaca/1248105728_0000.png',
        species_y: 'Ilex opaca',
        source: 'field',
        wiki_summary:
          'Ilex opaca, the American holly, is a species of holly, native to the eastern and south-central United States, from coastal Massachusetts south to central Florida, and west to southeastern Missouri and eastern Texas.\n\n',
        Longitude: -85.391812,
        Latitude: 32.917943,
      },
      geometry: { type: 'Point', coordinates: [-85.391812, 32.917943] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'HOLLY',
        subspecies: ' Dahoon',
        scientific_name: 'Ilex cassine',
        year_named: 2015.0,
        circumference_in: 58.0,
        height_in: 37.0,
        spread_ft: 33.0,
        total_points: 103.0,
        county: 'Baldwin',
        year_remeasured: 2020,
        owner: 'U.S. Fish & Wildlife Service',
        nominator: 'Chan West',
        sci_lc: 'ilex cassine',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/ilex_cassine/ilex_cassine.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Ilex cassine is a holly native to the southeastern coast of North America, in the United States from Virginia to southeast Texas, in Mexico in Veracruz, and in the Caribbean on the Bahamas, Cuba, and Puerto Rico. It is commonly known as dahoon holly or cassena, the latter derived from the Timucua name for I. vomitoria.It is a large shrub or small tree growing to 10–13 m tall. The leaves are evergreen, 6–15 cm long and 2–4 cm broad, glossy dark green, entire or with a few small spines near the apex of the leaf. The flowers are white, with a four-lobed corolla. The fruit is a red drupe, 5–6 mm in diameter, containing four seeds.As with other hollies, it is dioecious with separate male and female plants. Only the females have berries, and a male pollenizer must be within range for bees to pollinate them.',
        Longitude: -87.746067,
        Latitude: 30.659218,
      },
      geometry: { type: 'Point', coordinates: [-87.746067, 30.659218] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'HOPTREE',
        subspecies: 'N/A',
        scientific_name: 'Ptelea trifoliata',
        year_named: 2011.0,
        circumference_in: 17.0,
        height_in: 21.0,
        spread_ft: 18.0,
        total_points: 43.0,
        county: 'Jackson',
        year_remeasured: 2021,
        owner: 'The Nature Conservancy',
        nominator: 'Jason Shelton',
        sci_lc: 'ptelea trifoliata',
        file_id: 69010.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/ptelea_trifoliata/pi0003-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/ptelea_trifoliata/pi0003-01-1.png',
        species_y: 'Ptelea trifoliata',
        source: 'lab',
        wiki_summary:
          'Ptelea trifoliata, commonly known as common hoptree, wafer ash, stinking ash, and skunk bush, is a species of flowering plant in the citrus family (Rutaceae). It is native to North America, where it is found in Canada, Mexico, and the United States. It is a deciduous shrub or tree, with alternate, trifoliate leaves.\n\n',
        Longitude: -85.9774,
        Latitude: 34.763522,
      },
      geometry: { type: 'Point', coordinates: [-85.9774, 34.763522] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'HORNBEAM',
        subspecies: ' American',
        scientific_name: 'Carpinus caroliniana',
        year_named: 2012.0,
        circumference_in: 45.0,
        height_in: 61.0,
        spread_ft: 46.0,
        total_points: 118.0,
        county: 'Talladega',
        year_remeasured: 2017,
        owner: 'Margery B. McBride',
        nominator: 'John McBride',
        sci_lc: 'carpinus caroliniana',
        file_id: 55949.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/carpinus_caroliniana/pi0293-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/carpinus_caroliniana/pi0293-01-1.png',
        species_y: 'Carpinus caroliniana',
        source: 'lab',
        wiki_summary:
          'Carpinus caroliniana, the  American hornbeam, is a small hardwood tree in the genus Carpinus. American hornbeam is also known as blue-beech, and musclewood. It is native to eastern North America, from Minnesota and southern Ontario east to Maine, and south to eastern Texas and northern Florida. It also grows in Canada (southwest Quebec and southeast Ontario).',
        Longitude: -86.175805,
        Latitude: 33.369277,
      },
      geometry: { type: 'Point', coordinates: [-86.175805, 33.369277] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'LOBLOLLY-BAY',
        subspecies: 'N/A',
        scientific_name: 'Gordonia lasianthus',
        year_named: 2020.0,
        circumference_in: 59.0,
        height_in: 74.0,
        spread_ft: 29.0,
        total_points: 140.0,
        county: 'Baldwin',
        year_remeasured: 2025,
        owner: 'Aaron & Charity Barnhart',
        nominator: 'Gena Todia',
        sci_lc: 'gordonia lasianthus',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/gordonia_lasianthus/gordonia_lasianthus.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Gordonia lasianthus (loblolly-bay, holly-bay, gordonia, or bay) is a small to medium-sized evergreen tree or shrub found in acidic, swampy soils of pinelands and bays on the Atlantic and Gulf Coastal Plains of the southeastern United States. It is a member of the tea or family Theaceae.  It is slow growing with soft, light-colored (varies in color from cream to carmine), fine-grained wood of little commercial value, although loblolly-bay could be managed as a source of pulpwood.  When older specimens are cut, the wood exudes a strong scent.  It is similar to a mixture of fresh oranges and pine sap.  The bark of the adult tree varies from medium grey to a red brown coloration. Dead adult specimens of loblolly bay exhibit a lustrous shine when exposed to sunlight for several years.  The white showy flowers and shiny foliage make it a desirable ornamental, but it is not easy to cultivate. Deer browse stump sprouts heavily.',
        Longitude: -87.746067,
        Latitude: 30.659218,
      },
      geometry: { type: 'Point', coordinates: [-87.746067, 30.659218] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'LOCUST',
        subspecies: ' Black',
        scientific_name: 'Robinia pseudoacacia',
        year_named: 1995.0,
        circumference_in: 95.0,
        height_in: 102.0,
        spread_ft: 27.0,
        total_points: 204.0,
        county: 'Madison',
        year_remeasured: 2017,
        owner: 'Sydney & Elaine White',
        nominator: 'Susan Weber',
        sci_lc: 'robinia pseudoacacia',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/robinia_pseudoacacia/robinia_pseudoacacia.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Robinia pseudoacacia, commonly known in its native territory as black locust, is a medium-sized hardwood deciduous tree, belonging to the tribe Robinieae.  It is endemic to a few small areas of the United States, but it has been widely planted and naturalized elsewhere in temperate North America, Europe, Southern Africa and Asia and is considered an invasive species in some areas. Another common name is false acacia, a literal translation of the specific name (pseudo meaning fake or false and acacia referring to the genus of plants with the same name).',
        Longitude: -86.55108,
        Latitude: 34.764238,
      },
      geometry: { type: 'Point', coordinates: [-86.55108, 34.764238] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'LOCUST',
        subspecies: ' Honey',
        scientific_name: 'Gleditsia triacanthos',
        year_named: 2009.0,
        circumference_in: 94.0,
        height_in: 114.0,
        spread_ft: 58.0,
        total_points: 223.0,
        county: 'Talladega',
        year_remeasured: 2019,
        owner: 'Headwaters Investments Corp.',
        nominator: 'John Goff & Travis Ford',
        sci_lc: 'gleditsia triacanthos',
        file_id: 57771.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/gleditsia_triacanthos/pi1072-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/gleditsia_triacanthos/pi1072-01-1.png',
        species_y: 'Gleditsia triacanthos',
        source: 'lab',
        wiki_summary:
          'The honey locust (Gleditsia triacanthos),  also known as the thorny locust or thorny honeylocust, is a deciduous tree in the family Fabaceae, native to central North America where it is mostly found in the moist soil of river valleys. Honey locust is highly adaptable to different environments, has been introduced worldwide, and is an aggressive invasive species.\n\n',
        Longitude: -86.175805,
        Latitude: 33.369277,
      },
      geometry: { type: 'Point', coordinates: [-86.175805, 33.369277] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'MAGNOLIA',
        subspecies: ' Bigleaf',
        scientific_name: 'Magnolia macrophylla',
        year_named: 2017.0,
        circumference_in: 39.0,
        height_in: 65.0,
        spread_ft: 38.0,
        total_points: 114.0,
        county: 'Madison',
        year_remeasured: 2022,
        owner: 'Anthony and Tamara Carlisle',
        nominator: 'Anthony and Tamara Carlisle',
        sci_lc: 'magnolia macrophylla',
        file_id: 63293.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/magnolia_macrophylla/wb1253-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/magnolia_macrophylla/wb1253-01-1.png',
        species_y: 'Magnolia macrophylla',
        source: 'lab',
        wiki_summary:
          'Magnolia macrophylla, the bigleaf magnolia, is a deciduous magnolia native to the southeastern United States and eastern Mexico. This species boasts the largest simple leaf and single flower of any native plant in North America.',
        Longitude: -86.55108,
        Latitude: 34.764238,
      },
      geometry: { type: 'Point', coordinates: [-86.55108, 34.764238] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'CATALPA',
        subspecies: ' Southern',
        scientific_name: 'Catalpa bignonioides',
        year_named: 2020.0,
        circumference_in: 209.0,
        height_in: 60.0,
        spread_ft: 59.0,
        total_points: 284.0,
        county: 'Calhoun',
        year_remeasured: 2025,
        owner: 'McClellan Development Authority',
        nominator: 'John McBride, N',
        sci_lc: 'catalpa bignonioides',
        file_id: 57234.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/catalpa_bignonioides/pi1080-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/catalpa_bignonioides/pi1080-01-1.png',
        species_y: 'Catalpa bignonioides',
        source: 'lab',
        wiki_summary:
          'Catalpa bignonioides is a species of Catalpa that is native to the southeastern United States in Alabama, Florida, Georgia, Louisiana, and Mississippi. Common names include southern catalpa, cigartree, and Indian-bean-tree (or Indian bean tree).',
        Longitude: -85.822513,
        Latitude: 33.771706,
      },
      geometry: { type: 'Point', coordinates: [-85.822513, 33.771706] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'CEDAR',
        subspecies: ' Atlantic White',
        scientific_name: 'Chamaecyparis thyoides',
        year_named: 2020.0,
        circumference_in: 103.0,
        height_in: 81.0,
        spread_ft: 32.0,
        total_points: 192.0,
        county: 'Baldwin',
        year_remeasured: 2025,
        owner: 'Aaron & Charity Barnhart',
        nominator: 'Gena Todia, N',
        sci_lc: 'chameacyparis thyoides',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/chamaecyparis_thyoides/chamaecyparis_thyoides.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Chamaecyparis thyoides (Atlantic white cedar, Atlantic white cypress, southern white cedar, whitecedar, or false-cypress), a species of Cupressaceae, is native to the Atlantic coast of North America and is found from southern Maine to Georgia and along the Gulf of Mexico coast from Florida to Mississippi.  It is one of two species of Chamaecyparis found in North America.  C. thyoides resides on the East Coast and C. lawsoniana can be found on the West Coast. There are two geographically isolated subspecies, treated by some botanists as distinct species, by others at just varietal rank: Chamaecyparis thyoides thyoides and Chamaecyparis thyoides henryae (H.L.Li) E.Murray (syn. Chamaecyparis thyoides subsp. henryae (H.L.Li) Little; Chamaecyparis henryae H.L.Li) The species grows in forested wetlands where they tend to dominate the canopy.  The trees are associated with a wide variety of other wetland species because of their wide north-south range.  The remaining populations are now found mostly in remote locations that would be difficult to harvest, so its popularity as a source of lumber has decreased.',
        Longitude: -87.746067,
        Latitude: 30.659218,
      },
      geometry: { type: 'Point', coordinates: [-87.746067, 30.659218] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'CHERRY',
        subspecies: ' Alabama black',
        scientific_name: 'Prunus alabamensis',
        year_named: 2011.0,
        circumference_in: 40.0,
        height_in: 60.0,
        spread_ft: 40.0,
        total_points: 110.0,
        county: 'Tuscaloosa',
        year_remeasured: 2016,
        owner: 'University of Alabama',
        nominator: 'Dexter Duren',
        sci_lc: 'prunus alabamensis',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/prunus_alabamensis/prunus_alabamensis.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Prunus alabamensis, the Alabama cherry or Alabama black cherry, is an uncommon North American species of shrub tree native to the southeastern United States (Alabama, Florida, Georgia, South Carolina).Prunus alabamensis is a shrub or small tree up to 15 feet (450 cm) tall. Leaves are thick, broadly egg-shaped dull green on the upper surface, light green on the underside. Flowers are in an elongated raceme up to 6 inches (15 cm) long.',
        Longitude: -87.52286,
        Latitude: 33.290202,
      },
      geometry: { type: 'Point', coordinates: [-87.52286, 33.290202] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'CHERRY',
        subspecies: ' Black',
        scientific_name: 'Prunus serotina',
        year_named: 2009.0,
        circumference_in: 147.0,
        height_in: 79.0,
        spread_ft: 79.0,
        total_points: 246.0,
        county: 'Madison',
        year_remeasured: 2019,
        owner: 'Roger Everett & Joyce Rutland',
        nominator: 'Doug Chapman',
        sci_lc: 'prunus serotina',
        file_id: 4314.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/field/prunus_serotina/1248105888_0000.jpg?raw=true',
        segmented_path:
          'dataset/segmented/field/prunus_serotina/1248105888_0000.png',
        species_y: 'Prunus serotina',
        source: 'field',
        wiki_summary:
          'Prunus serotina, commonly called black cherry, wild black cherry, rum cherry, or mountain black cherry, is a deciduous tree or shrub of the genus Prunus. Despite being called black cherry, it is not very closely related to the commonly cultivated cherries such as sweet cherry (P. avium), sour cherry (P. cerasus) and Japanese flowering cherries (P. serrulata, P. speciosa, P. sargentii, P. incisa, etc.) which belong to Prunus subg. Cerasus. Instead, P. serotina belongs to Prunus subg. Padus, a subgenus also including Eurasian bird cherry (P. padus) and chokecherry (P. virginiana). The species is widespread and common in North America and South America.\n\nBlack cherry is closely related to the chokecherry (P. virginiana); chokecherry, however, tends to be shorter (a shrub or small tree) and has smaller, less glossy leaves.',
        Longitude: -86.55108,
        Latitude: 34.764238,
      },
      geometry: { type: 'Point', coordinates: [-86.55108, 34.764238] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'CHERRY',
        subspecies: ' Carolina Laurel',
        scientific_name: 'Prunus caroliniana',
        year_named: 2020.0,
        circumference_in: 82.0,
        height_in: 36.0,
        spread_ft: 37.0,
        total_points: 127.0,
        county: 'Elmore',
        year_remeasured: 2025,
        owner: 'Steve Albritton',
        nominator: 'Steve Albritton',
        sci_lc: 'prunus caroliniana',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/prunus_caroliniana/prunus_caroliniana.png?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Prunus caroliniana, known as the Carolina laurelcherry, Carolina cherry laurel, cherry laurel, or Carolina cherry, is a small evergreen flowering tree native to the lowlands of Southeastern United States, from North Carolina south to Florida and westward to central Texas. The species has also escaped into the wild in a few places in California.Prunus caroliniana is not to be confused with its European relative Prunus laurocerasus, which is also called Cherry Laurel, though mainly known as English Laurel in the U.S.',
        Longitude: -86.142739,
        Latitude: 32.597229,
      },
      geometry: { type: 'Point', coordinates: [-86.142739, 32.597229] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'CHESTNUT',
        subspecies: ' Chinese',
        scientific_name: 'Castanea mollissima',
        year_named: 1998.0,
        circumference_in: 138.0,
        height_in: 65.0,
        spread_ft: 77.0,
        total_points: 222.0,
        county: 'Coosa',
        year_remeasured: 2017,
        owner: 'George & Ronnie Zak',
        nominator: 'Blake Kelley',
        sci_lc: 'castanea mollissima',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/castanea_mollissima/castanea_mollissima.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Castanea mollissima (Chinese: 板栗; pinyin: bǎnlì), also known as the Chinese chestnut, is a member of the family Fagaceae, and a species of chestnut native to China, Taiwan, and Korea.',
        Longitude: -86.243482,
        Latitude: 32.931445,
      },
      geometry: { type: 'Point', coordinates: [-86.243482, 32.931445] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'CHINKAPIN',
        subspecies: ' Allegheny',
        scientific_name: 'Castanea pumila',
        year_named: 2011.0,
        circumference_in: 13.0,
        height_in: 26.0,
        spread_ft: 16.0,
        total_points: 43.0,
        county: 'Winston',
        year_remeasured: 2021,
        owner: 'U. S. Forest Service',
        nominator: 'Jason Shelton',
        sci_lc: 'castanea pumila',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/castanea_pumila/castanea_pumila.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          "Castanea pumila, commonly known as the Allegheny chinquapin, American chinquapin (from the Powhatan) or dwarf chestnut, is a species of chestnut native to the southeastern United States. The native range is from Maryland and extreme southern New Jersey and southeast Pennsylvania south to central Florida, west to eastern Texas, and north to southern Missouri and Kentucky. The plant's habitat is dry sandy and rocky uplands and ridges mixed with oak and hickory to 1000 m elevation. It grows best on well-drained soils in full sun or partial shade.",
        Longitude: -87.364147,
        Latitude: 34.155888,
      },
      geometry: { type: 'Point', coordinates: [-87.364147, 34.155888] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'COTTONWOOD',
        subspecies: ' Eastern',
        scientific_name: 'Populus deltoides',
        year_named: 2011.0,
        circumference_in: 146.0,
        height_in: 121.0,
        spread_ft: 73.0,
        total_points: 285.0,
        county: 'Chambers',
        year_remeasured: 2016,
        owner: 'Glenn Osborn',
        nominator: 'Fred & Lavonia Osborn',
        sci_lc: 'populus deltoides',
        file_id: 67566.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/populus_deltoides/wb1163-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/populus_deltoides/wb1163-01-1.png',
        species_y: 'Populus deltoides',
        source: 'lab',
        wiki_summary:
          'Populus deltoides, the eastern cottonwood or necklace poplar, is a cottonwood poplar native to North America, growing throughout the eastern, central, and southwestern United States as well as the southern Canadian prairies, the southernmost part of eastern Canada, and northeastern Mexico.',
        Longitude: -85.391812,
        Latitude: 32.917943,
      },
      geometry: { type: 'Point', coordinates: [-85.391812, 32.917943] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'COTTONWOOD',
        subspecies: ' Swamp',
        scientific_name: 'Populus heterophylla',
        year_named: 2010.0,
        circumference_in: 74.0,
        height_in: 61.0,
        spread_ft: 41.0,
        total_points: 145.0,
        county: 'Baldwin',
        year_remeasured: 2016,
        owner: 'Vermelle McDill',
        nominator: 'Joseph Donnelly',
        sci_lc: 'populus heterophylla',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/populus_heterophylla/populus_heterophylla.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Populus heterophylla, also known as downy poplar, swamp poplar and swamp cottonwood, is a large deciduous poplar belonging to the Populus genus of the family Salicaceae. This species can grow on sites that have too much water for other native poplars. On the IUCN Red List this species is listed as "least concern".',
        Longitude: -87.746067,
        Latitude: 30.659218,
      },
      geometry: { type: 'Point', coordinates: [-87.746067, 30.659218] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'CRAPE MYRTLE',
        subspecies: 'N/A',
        scientific_name: 'Lagerstroemia indica',
        year_named: 2011.0,
        circumference_in: 78.0,
        height_in: 43.0,
        spread_ft: 33.0,
        total_points: 129.0,
        county: 'Wilcox',
        year_remeasured: 2016,
        owner: 'Malcolm Smith',
        nominator: 'Malcolm Smith',
        sci_lc: 'lagerstroemia indica',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/lagerstroemia_indica/lagerstroemia_indica.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Lagerstroemia indica, the crape myrtle (also crepe myrtle, crêpe myrtle, or crepeflower) is a species of flowering plant in the genus Lagerstroemia of the family Lythraceae. It is native  to the Indian Subcontinent (hence the species epithet indica), and also to Southeast Asia, China, Korea and Japan. The genus name honors Swedish botanist Magnus von Lagerstroem. It is an often multi-stemmed, deciduous tree with a wide spreading, flat topped, rounded, or even spike shaped open habit. The tree is a popular nesting shrub for songbirds and wrens.\nIn the United Kingdom, Lagerstroemia indica has gained the Royal Horticultural Society’s Award of Garden Merit.',
        Longitude: -87.302205,
        Latitude: 31.99033,
      },
      geometry: { type: 'Point', coordinates: [-87.302205, 31.99033] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'CYRILLA',
        subspecies: ' Swamp',
        scientific_name: 'Cyrilla racemiflora',
        year_named: 1996.0,
        circumference_in: 43.0,
        height_in: 31.0,
        spread_ft: 20.0,
        total_points: 79.0,
        county: 'Mobile',
        year_remeasured: 2018,
        owner: 'University of Mobile',
        nominator: 'Patrick Waldrop',
        sci_lc: 'cyrilla racemiflora',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/cyrilla_racemiflora/cyrilla_racemiflora.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Cyrilla racemiflora, the sole species in the genus Cyrilla, is a flowering plant in the family Cyrillaceae, native to warm temperate to tropical regions of the Americas, from the southeastern United States (coastal areas from southeastern Texas east to southeastern Virginia), south through the Caribbean, Mexico (Oaxaca only) and Central America to northern Brazil and Colombia in South America. Common names include swamp cyrilla, swamp titi, red titi, black titi, white titi, leatherwood, ironwood, he huckleberry, and myrtle.\n\n',
        Longitude: -88.196568,
        Latitude: 30.684573,
      },
      geometry: { type: 'Point', coordinates: [-88.196568, 30.684573] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'DEVILWOOD',
        subspecies: 'N/A',
        scientific_name: 'Osmanthus americanus',
        year_named: 2017.0,
        circumference_in: 20.0,
        height_in: 53.0,
        spread_ft: 15.0,
        total_points: 77.0,
        county: 'Coffee',
        year_remeasured: 2022,
        owner: 'Adam Dasinger',
        nominator: 'Adam Dasinger',
        sci_lc: 'osmanthus americanus',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/osmanthus_americanus/osmanthus_americanus.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Cartrema americana, commonly called American olive, wild olive, or devilwood, is an evergreen shrub or small tree native to southeastern North America, in the United States from Virginia to Texas, and in Mexico from Nuevo León south to Oaxaca and Veracruz.Cartrema americana was formerly classified as Osmanthus americanus. Following the discovery that Osmanthus was polyphyletic, it was transferred to the segregate genus Cartrema together with Osmanthus floridanus and five Asian species.Cartrema americana grows to 4–7 m (13–23 ft), rarely to 11 m (36 ft) tall. The leaves are 5–14 cm (2.0–5.5 in) long and 2–4 cm (0.79–1.57 in) broad, with an entire margin. Its flowers, produced in early spring, are small (1 cm long), white, with a four-lobed corolla and have a strong fragrance. The fruit is a globose dark blue drupe 6–15 mm (0.24–0.59 in) diameter, containing a single seed.It is cultivated as an ornamental plant in gardens for its fragrant flowers.',
        Longitude: -85.989201,
        Latitude: 31.402183,
      },
      geometry: { type: 'Point', coordinates: [-85.989201, 31.402183] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'DOGWOOD',
        subspecies: ' Flowering',
        scientific_name: 'Cornus florida',
        year_named: 2009.0,
        circumference_in: 74.0,
        height_in: 48.0,
        spread_ft: 59.0,
        total_points: 137.0,
        county: 'Cleburne',
        year_remeasured: 2019,
        owner: 'Jeff & Nicki Swindle',
        nominator: 'Glenn Berry',
        sci_lc: 'cornus florida',
        file_id: 60121.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/cornus_florida/wb8001-01-1.jpg?raw=true',
        segmented_path: 'dataset/segmented/lab/cornus_florida/wb8001-01-1.png',
        species_y: 'Cornus florida',
        source: 'lab',
        wiki_summary:
          'Cornus florida, the flowering dogwood, is a species of flowering tree in the family Cornaceae native to eastern North America and northern Mexico. An endemic population once spanned from southernmost coastal Maine south to northern Florida and west to the Mississippi River.  The tree is commonly planted as an ornamental in residential and public areas because of its showy bracts and interesting bark structure.\n\n',
        Longitude: -85.516109,
        Latitude: 33.671981,
      },
      geometry: { type: 'Point', coordinates: [-85.516109, 33.671981] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'ELM',
        subspecies: ' American',
        scientific_name: 'Ulmus americana',
        year_named: 2008.0,
        circumference_in: 194.0,
        height_in: 92.0,
        spread_ft: 84.0,
        total_points: 307.0,
        county: 'Walker',
        year_remeasured: 2018,
        owner: 'Diane Cheatham',
        nominator: 'Paul Kennedy & Dan Jackson',
        sci_lc: 'ulmus americana',
        file_id: 4407.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/field/ulmus_americana/1249059004_0000.jpg?raw=true',
        segmented_path:
          'dataset/segmented/field/ulmus_americana/1249059004_0000.png',
        species_y: 'Ulmus americana',
        source: 'field',
        wiki_summary:
          "Ulmus americana, generally known as the American elm or, less commonly, as the white elm or water elm, is a species of elm native to eastern North America, naturally occurring from Nova Scotia west to Alberta and Montana, and south to Florida and central Texas. The American elm is an extremely hardy tree that can withstand winter temperatures as low as −42 °C (−44 °F). Trees in areas unaffected by Dutch elm disease (DED) can live for several hundred years. A prime example of the species was the Sauble Elm, which grew beside the banks of the Sauble River in Ontario, Canada, to a height of 43 m (140 ft), with a d.b.h of 196 cm (6.43 ft) before succumbing to DED; when it was felled in 1968, a tree-ring count established that it had germinated in 1701.\nFor over 80 years, U. americana had been identified as a tetraploid, i.e. having double the usual number of chromosomes, making it unique within the genus. However, a study published in 2011 by the Agricultural Research Service of the USDA revealed that about 20% of wild American elms are diploid and may even constitute another species. Moreover, several triploid trees known only in cultivation, such as 'Jefferson', are possessed of a high degree of resistance to DED, which ravaged American elms in the 20th century. This suggests that the diploid parent trees, which have markedly smaller cells than the tetraploid, may too be highly resistant to the disease.\n\n",
        Longitude: -87.301092,
        Latitude: 33.791571,
      },
      geometry: { type: 'Point', coordinates: [-87.301092, 33.791571] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'ELM',
        subspecies: ' September',
        scientific_name: 'Ulmus serotina',
        year_named: 2011.0,
        circumference_in: 62.0,
        height_in: 100.0,
        spread_ft: 54.0,
        total_points: 176.0,
        county: 'Lauderdale',
        year_remeasured: 2021,
        owner: 'Joe Wheeler State Park',
        nominator: 'Jason Shelton',
        sci_lc: 'ulmus serotina',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/ulmus_serotina/ulmus_serotina.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Ulmus serotina Sarg., the September elm, is an autumn-flowering North American species of tree. It is uncommon beyond Tennessee; only very locally distributed through Illinois, Kentucky, Arkansas, Mississippi, Oklahoma, Alabama and Georgia, and disjunct into Nuevo León, Mexico. It grows predominantly on limestone bluffs and along streams to elevations of 400 m.',
        Longitude: -87.650997,
        Latitude: 34.904122,
      },
      geometry: { type: 'Point', coordinates: [-87.650997, 34.904122] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'ELM',
        subspecies: ' Water',
        scientific_name: 'Planera aquatica',
        year_named: 1982.0,
        circumference_in: 57.0,
        height_in: 60.0,
        spread_ft: 39.0,
        total_points: 127.0,
        county: 'Covington',
        year_remeasured: 2018,
        owner: 'Solon Dixon Forestry Center',
        nominator: 'Dr. Harry Larsen',
        sci_lc: 'planera aquatica',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/planera_aquatica/planera_aquatica.png?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Planera is a genus of flowering plants with a single species, Planera aquatica, the planertree or water elm. Found in the southeastern United States, it is a small deciduous tree 10–15 m tall, closely related to the elms but with a softly, prickly nut 10–15 mm diameter, instead of a winged seed. It grows, as the name suggests, on wet sites. Despite its common English name, this species is not a true elm, although it is a close relative of the elms (species of the genus Ulmus). It is also subject to Dutch elm disease, a disease which affects only members of the Ulmaceae. It is native to most of the southeast United States. It is hardy down to Zone 7.',
        Longitude: -86.448721,
        Latitude: 31.243987,
      },
      geometry: { type: 'Point', coordinates: [-86.448721, 31.243987] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'ELM',
        subspecies: ' Winged',
        scientific_name: 'Ulmus alata',
        year_named: 1997.0,
        circumference_in: 142.0,
        height_in: 85.0,
        spread_ft: 74.0,
        total_points: 246.0,
        county: 'Wilcox',
        year_remeasured: 2018,
        owner: 'Kinley Bell',
        nominator: 'Paul Wingard',
        sci_lc: 'ulmus alata',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/ulmus_alata/ulmus_alata.png?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Ulmus alata, the winged elm or wahoo, is a small- to medium-sized deciduous tree endemic to the woodlands of the southeastern and south-central United States. The species is tolerant of a wide range of soils, and of ponding, but is the least shade-tolerant of the North American elms. Its growth rate is often very slow, the trunk increasing in diameter by less than 5 mm (3⁄16 in) per year. The tree is occasionally considered a nuisance as it readily invades old fields, forest clearings, and rangelands, proving particularly difficult to eradicate with herbicides.\n\n',
        Longitude: -87.302205,
        Latitude: 31.99033,
      },
      geometry: { type: 'Point', coordinates: [-87.302205, 31.99033] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'FRINGETREE',
        subspecies: 'N/A',
        scientific_name: 'Chionanthus virginicus',
        year_named: 2010.0,
        circumference_in: 32.0,
        height_in: 18.0,
        spread_ft: 25.0,
        total_points: 55.0,
        county: 'Tuscaloosa',
        year_remeasured: 2020,
        owner: 'Robert I. Jones',
        nominator: 'Dexter Duren',
        sci_lc: 'chionanthus virginicus',
        file_id: 59773.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/chionanthus_virginicus/pi0034-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/chionanthus_virginicus/pi0034-01-1.png',
        species_y: 'Chionanthus virginicus',
        source: 'lab',
        wiki_summary:
          'Chionanthus virginicus (white fringetree) is a tree native to the savannas and lowlands of the southeastern United States, from New Jersey south to Florida, and west to Oklahoma and Texas.',
        Longitude: -87.52286,
        Latitude: 33.290202,
      },
      geometry: { type: 'Point', coordinates: [-87.52286, 33.290202] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'HACKBERRY',
        subspecies: ' Common',
        scientific_name: 'Celtis occidentalis',
        year_named: 2009.0,
        circumference_in: 189.0,
        height_in: 73.0,
        spread_ft: 92.0,
        total_points: 285.0,
        county: 'Marshall',
        year_remeasured: 2019,
        owner: 'John & Sue White',
        nominator: 'Sue White',
        sci_lc: 'celtis occidentalis',
        file_id: 4340.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/field/celtis_occidentalis/1248106179_0000.jpg?raw=true',
        segmented_path:
          'dataset/segmented/field/celtis_occidentalis/1248106179_0000.png',
        species_y: 'Celtis occidentalis',
        source: 'field',
        wiki_summary:
          'Celtis occidentalis, commonly known as the common hackberry, is a large deciduous tree native to North America. It is also known as the nettletree, sugarberry, beaverwood, northern hackberry, and American hackberry. It is a moderately long-lived hardwood with a light-colored wood, yellowish gray to light brown with yellow streaks.The common hackberry is easily distinguished from elms and some other hackberries by its cork-like bark with wart-like protuberances. The leaves are distinctly asymmetrical and coarse-textured.  It produces small fruits that turn orange-red to dark purple in the autumn, often staying on the trees for several months.  The common hackberry is easily confused with the sugarberry (Celtis laevigata) and is most easily distinguished by range and habitat.  The common hackberry also has wider leaves that are coarser above than the sugarberry.',
        Longitude: -86.321668,
        Latitude: 34.309564,
      },
      geometry: { type: 'Point', coordinates: [-86.321668, 34.309564] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'HAWTHORN',
        subspecies: ' Dotted',
        scientific_name: 'Crataegus punctata',
        year_named: 1994.0,
        circumference_in: 13.0,
        height_in: 26.0,
        spread_ft: 18.0,
        total_points: 44.0,
        county: 'Madison',
        year_remeasured: 2017,
        owner: 'Harriot Ross Grable',
        nominator: 'Susan Weber',
        sci_lc: 'crataegus punctata',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/crataegus_punctata/crataegus_punctata.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Crataegus punctata is a species of hawthorn known by the common names dotted hawthorn or white haw that is native to most of the eastern United States and eastern Canada. While some sources claim it is the state flower of Missouri, the actual legislation does not identify an exact species. Furthermore, the Missouri Department of Conservation asserts the Crataegus mollis was specifically designated as the state flower.Although many North American hawthorns are polyploid and reproduce by apomixis, this species is apparently diploid and sexual, at least throughout Ontario, Canada. The name white haw refers to its distinctive pale (grey) bark, which is particularly noticeable in the winter landscape. The plant is a bush or small tree to about 7 meters in height and very thorny, particularly on the trunk. The flower has three to five styles and approximately 20 stamens, and the fruit has three to five nutlets. Anther colour varies from deep purple through red to pink to white, and the mature fruit colour can be deep burgundy, scarlet, yellow, or yellow with a red cheek.',
        Longitude: -86.55108,
        Latitude: 34.764238,
      },
      geometry: { type: 'Point', coordinates: [-86.55108, 34.764238] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'HAWTHORN',
        subspecies: ' Littlehip',
        scientific_name: 'Crataegus spathulata',
        year_named: 2009.0,
        circumference_in: 14.0,
        height_in: 28.0,
        spread_ft: 16.0,
        total_points: 46.0,
        county: 'DeKalb',
        year_remeasured: 2025,
        owner: 'DeSoto State Park',
        nominator: 'Jason Shelton',
        sci_lc: 'crataegus spathulta',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/crataegus_spathulata/crataegus_spathulata.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Crataegus spathulata is a species hawthorn known by the common name littlehip hawthorn. It is native to the southeastern United States. It has very attractive small delicate leaves with a bluish appearance, pretty flowers and small orange to red fruit.',
        Longitude: -85.803992,
        Latitude: 34.460929,
      },
      geometry: { type: 'Point', coordinates: [-85.803992, 34.460929] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'ALDER',
        subspecies: ' Hazel',
        scientific_name: 'Alnus serrulata',
        year_named: 2013.0,
        circumference_in: 15.0,
        height_in: 36.0,
        spread_ft: 18.0,
        total_points: 56.0,
        county: 'Talladega',
        year_remeasured: 2018,
        owner: 'Allen McBride',
        nominator: 'John McBride',
        sci_lc: 'alnus serrulata',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/alnus_serrulata/alnus_serrulata.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Alnus serrulata, the hazel alder or smooth alder, is a thicket-forming shrub in the family Betulaceae. It is native to eastern North America and can be found from western Nova Scotia and southern New Brunswick south to Florida and Texas.',
        Longitude: -86.175805,
        Latitude: 33.369277,
      },
      geometry: { type: 'Point', coordinates: [-86.175805, 33.369277] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'AMERICAN SMOKETREE',
        subspecies: 'N/A',
        scientific_name: ' Cotinus obovatus',
        year_named: 2010.0,
        circumference_in: 61.0,
        height_in: 64.0,
        spread_ft: 38.0,
        total_points: 135.0,
        county: 'Madison',
        year_remeasured: 2021,
        owner: 'Carol Rampey',
        nominator: 'Melody Stewart',
        sci_lc: 'cotinus obovatu',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/_cotinus_obovatus/_cotinus_obovatus.JPG?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Cotinus obovatus syn. C. americanus, the American smoketree, chittamwood or American smokewood, is a rare species of flowering plant in the genus Cotinus of the family Anacardiaceae, native to Oklahoma, Texas, Arkansas, Missouri, Alabama and Tennessee. It is a deciduous, conical shrub growing to 10 m (33 ft) tall by 8 m (26 ft) broad, with oval leaves up to 12 cm (5 in) long. It produces panicles of pink-grey flowers in summer, and its foliage turns a brilliant scarlet in autumn; considered by many to be the most intense fall color of any tree. The smokey effect derives from the clusters of hairs on the spent flower stalks. It is highly sought after and cultivated in botanical gardens world wide.The Latin specific epithet obovatus means "in the shape of an inverted egg", and refers to the broadly oval shape of the leaves. The heartwood is a bright yellow. The species may be facing extinction in the wild.',
        Longitude: -86.55108,
        Latitude: 34.764238,
      },
      geometry: { type: 'Point', coordinates: [-86.55108, 34.764238] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'APPLE',
        subspecies: ' Southern crab',
        scientific_name: 'Malus angustifolia',
        year_named: 2002.0,
        circumference_in: 59.0,
        height_in: 39.0,
        spread_ft: 27.0,
        total_points: 105.0,
        county: 'Montgomery',
        year_remeasured: 2017,
        owner: 'Silas Bonner',
        nominator: 'Brent Gohring',
        sci_lc: 'malus angustifolia',
        file_id: 64265.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/malus_angustifolia/pi2415-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/malus_angustifolia/pi2415-01-1.png',
        species_y: 'Malus angustifolia',
        source: 'lab',
        wiki_summary:
          'Malus angustifolia, or southern crabapple, is a species of crabapple native to the eastern and south-central United States from Florida west to eastern Texas and north to New Jersey, Pennsylvania, Illinois and Missouri.Malus angustifolia is a tree sometimes attaining a height of 10 meters (33 feet). The trunk can have a diameter up to 25 cm (10 inches). Flowers are pink, with a pleasant scent. The fruits are up to 3 cm (1.2 inches) in diameter, and have an aromatic scent and a pear-like shape. They are astringent and acidic and not palatable when raw, but can be used to make jellies, jams and food preserves. They are also eaten by various wildlife.The tree is grown as an ornamental plant.\n\nVarietiesMalus angustifolia var. angustifolia\nMalus angustifolia var. puberula  (Rehder) Rehder',
        Longitude: -86.203831,
        Latitude: 32.203651,
      },
      geometry: { type: 'Point', coordinates: [-86.203831, 32.203651] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'ASH',
        subspecies: ' Blue',
        scientific_name: 'Fraxinus quadrangulata',
        year_named: 2012.0,
        circumference_in: 84.0,
        height_in: 80.0,
        spread_ft: 41.0,
        total_points: 174.0,
        county: 'Jackson',
        year_remeasured: 2017,
        owner: 'National Park Service',
        nominator: 'Jason Shelton',
        sci_lc: 'fraxinus quadrangulata',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/fraxinus_quadrangulata/fraxinus_quadrangulata.JPG?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Fraxinus quadrangulata, the blue ash, is a species of ash native primarily to the Midwestern United States from Oklahoma to Michigan, as well as the Bluegrass region of Kentucky and the Nashville Basin region of Tennessee. Isolated populations exist in Alabama, Southern Ontario, and small sections of the Appalachian Mountains. It is typically found over calcareous substrates such as limestone, growing on limestone slopes and in moist valley soils, at elevations of 120–600 m.',
        Longitude: -85.9774,
        Latitude: 34.763522,
      },
      geometry: { type: 'Point', coordinates: [-85.9774, 34.763522] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'ASH',
        subspecies: ' Green',
        scientific_name: 'Fraxinus pennsylvanica',
        year_named: 2000.0,
        circumference_in: 177.0,
        height_in: 88.0,
        spread_ft: 84.0,
        total_points: 286.0,
        county: 'Wilcox',
        year_remeasured: 2018,
        owner: 'Allyrae Wallace Educational Trust',
        nominator: 'Jesse Bell',
        sci_lc: 'fraxinus pennsylvanica',
        file_id: 4779.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/field/fraxinus_pennsylvanica/1249580105_0000.jpg?raw=true',
        segmented_path:
          'dataset/segmented/field/fraxinus_pennsylvanica/1249580105_0000.png',
        species_y: 'Fraxinus pennsylvanica',
        source: 'field',
        wiki_summary:
          'Fraxinus pennsylvanica, the green ash or red ash, is a species of ash native to eastern and central North America, from Nova Scotia west to southeastern Alberta and eastern Colorado, south to northern Florida, and southwest to Oklahoma and eastern Texas. It has spread and become naturalized in much of the western United States and also in Europe from Spain to Russia.Other names more rarely used include downy ash, swamp ash and water ash.\n\n',
        Longitude: -87.302205,
        Latitude: 31.99033,
      },
      geometry: { type: 'Point', coordinates: [-87.302205, 31.99033] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'ASH',
        subspecies: ' White',
        scientific_name: 'Fraxinus americana',
        year_named: 2020.0,
        circumference_in: 156.0,
        height_in: 74.0,
        spread_ft: 92.0,
        total_points: 253.0,
        county: 'Shelby',
        year_remeasured: 2025,
        owner: 'Clay Holland',
        nominator: 'Charles Ford',
        sci_lc: 'fraxinus americana',
        file_id: 4824.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/field/fraxinus_americana/1249580400_0000.jpg?raw=true',
        segmented_path:
          'dataset/segmented/field/fraxinus_americana/1249580400_0000.png',
        species_y: 'Fraxinus americana',
        source: 'field',
        wiki_summary:
          'Fraxinus americana, the white ash or American ash, is a species of ash tree native to eastern and central North America. It is found in mesophytic hardwood forests from Nova Scotia west to Minnesota, south to northern Florida, and southwest to eastern Texas. Isolated populations have also been found in western Texas, Wyoming, and Colorado, and the species is reportedly naturalized in Hawaii.There are an estimated 8 billion ash trees in the United States – the majority being the white ash trees and the green ash trees.',
        Longitude: -86.678104,
        Latitude: 33.262937,
      },
      geometry: { type: 'Point', coordinates: [-86.678104, 33.262937] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'BALDCYPRESS',
        subspecies: 'N/A',
        scientific_name: 'Taxodium distichum',
        year_named: 1989.0,
        circumference_in: 326.0,
        height_in: 112.0,
        spread_ft: 56.0,
        total_points: 452.0,
        county: 'Baldwin',
        year_remeasured: 2016,
        owner: 'AL Dep’t. of Conservation',
        nominator: 'Michael Jordon & John Martin',
        sci_lc: 'taxodium distichum',
        file_id: 73845.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/taxodium_distichum/wb1136-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/taxodium_distichum/wb1136-01-1.png',
        species_y: 'Taxodium distichum',
        source: 'lab',
        wiki_summary:
          'Taxodium distichum (bald cypress; French: cyprès chauve;\ncipre in Louisiana) is a deciduous conifer in the family Cupressaceae. It is native to the southeastern United States. Hardy and tough, this tree adapts to a wide range of soil types, whether wet, salty, dry, or swampy. It is noted for the russet-red fall color of its lacy needles.\nThis plant has some cultivated varieties and is often used in groupings in public spaces. Common names include bald cypress, baldcypress, swamp cypress, white cypress, tidewater red cypress, gulf cypress and red cypress.',
        Longitude: -87.746067,
        Latitude: 30.659218,
      },
      geometry: { type: 'Point', coordinates: [-87.746067, 30.659218] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'BASSWOOD',
        subspecies: 'N/A',
        scientific_name: 'Tilia spp.',
        year_named: 2016.0,
        circumference_in: 131.0,
        height_in: 115.0,
        spread_ft: 52.0,
        total_points: 259.0,
        county: 'Madison',
        year_remeasured: 2021,
        owner: 'City of Huntsville',
        nominator: 'Susan Weber',
        sci_lc: 'tilia spp.',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/tilia_spp./tilia_spp..png?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary: 'Not a valid scientific name.',
        Longitude: -86.55108,
        Latitude: 34.764238,
      },
      geometry: { type: 'Point', coordinates: [-86.55108, 34.764238] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'BAYBERRY',
        subspecies: ' Odorless',
        scientific_name: 'Morella inodora',
        year_named: 2000.0,
        circumference_in: 15.0,
        height_in: 27.0,
        spread_ft: 16.0,
        total_points: 46.0,
        county: 'Baldwin',
        year_remeasured: 2016,
        owner: 'City of Daphne',
        nominator: 'Dr. Harry Larsen & Fred Nation',
        sci_lc: 'morella inodora',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/morella_inodora/morella_inodora.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Myrica inodora is a plant species native to the coastal plains on the northern shore of the Gulf of Mexico, in the Florida Panhandle, the extreme southern parts of Alabama and Mississippi, eastern Louisiana and southwestern Georgia. Common names include scentless bayberry, odorless bayberry, odorless wax-myrtle, waxberry, candleberry, and waxtree. It grows in swamps, bogs, pond edges and stream banks.Myrica inodora is an evergreen, monoecious shrub or small tree up to 7 m (23 feet) tall. Leaves are ovate to elliptic, up to 12 cm (5 inches) long, lacking the odor characteristic of other members of the genus. Fruits are spherical or nearly so, up to 8 mm (0.3 inches) in diameter, covered with whitish wax and glandular hairs.',
        Longitude: -87.746067,
        Latitude: 30.659218,
      },
      geometry: { type: 'Point', coordinates: [-87.746067, 30.659218] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'BEECH',
        subspecies: ' American',
        scientific_name: 'Fagus grandifolia',
        year_named: 2015.0,
        circumference_in: 114.0,
        height_in: 131.0,
        spread_ft: 74.0,
        total_points: 264.0,
        county: 'Autauga',
        year_remeasured: 2020,
        owner: 'City of Prattville',
        nominator: 'Deven Peek',
        sci_lc: 'fagus grandifolia',
        file_id: 56844.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/fagus_grandifolia/wb1001-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/fagus_grandifolia/wb1001-01-1.png',
        species_y: 'Fagus grandifolia',
        source: 'lab',
        wiki_summary:
          'Fagus grandifolia, the American beech or North American beech, is the species of beech tree native to the eastern United States and extreme southeast Canada.\nThe genus name Fagus is Latin for "beech", and the specific epithet grandifolia comes from grandis "large" and folium "leaf".',
        Longitude: -86.64449,
        Latitude: 32.536382,
      },
      geometry: { type: 'Point', coordinates: [-86.64449, 32.536382] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'BEECH',
        subspecies: ' American',
        scientific_name: 'Fagus grandifolia',
        year_named: 2013.0,
        circumference_in: 132.0,
        height_in: 110.0,
        spread_ft: 83.0,
        total_points: 263.0,
        county: 'Jackson',
        year_remeasured: 2018,
        owner: 'C. John Brewer',
        nominator: 'C. John Brewer',
        sci_lc: 'fagus grandifolia',
        file_id: 56844.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/fagus_grandifolia/wb1001-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/fagus_grandifolia/wb1001-01-1.png',
        species_y: 'Fagus grandifolia',
        source: 'lab',
        wiki_summary:
          'Fagus grandifolia, the American beech or North American beech, is the species of beech tree native to the eastern United States and extreme southeast Canada.\nThe genus name Fagus is Latin for "beech", and the specific epithet grandifolia comes from grandis "large" and folium "leaf".',
        Longitude: -85.9774,
        Latitude: 34.763522,
      },
      geometry: { type: 'Point', coordinates: [-85.9774, 34.763522] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'BEECH',
        subspecies: ' American',
        scientific_name: 'Fagus grandifolia',
        year_named: 2003.0,
        circumference_in: 143.0,
        height_in: 101.0,
        spread_ft: 56.0,
        total_points: 258.0,
        county: 'Autauga',
        year_remeasured: 2018,
        owner: 'Cary McDaniel',
        nominator: 'Cary McDaniel',
        sci_lc: 'fagus grandifolia',
        file_id: 56844.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/fagus_grandifolia/wb1001-01-1.jpg?raw=true',
        segmented_path:
          'dataset/segmented/lab/fagus_grandifolia/wb1001-01-1.png',
        species_y: 'Fagus grandifolia',
        source: 'lab',
        wiki_summary:
          'Fagus grandifolia, the American beech or North American beech, is the species of beech tree native to the eastern United States and extreme southeast Canada.\nThe genus name Fagus is Latin for "beech", and the specific epithet grandifolia comes from grandis "large" and folium "leaf".',
        Longitude: -86.64449,
        Latitude: 32.536382,
      },
      geometry: { type: 'Point', coordinates: [-86.64449, 32.536382] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'BIRCH',
        subspecies: ' River',
        scientific_name: 'Betula nigra ',
        year_named: 2014.0,
        circumference_in: 100.0,
        height_in: 92.0,
        spread_ft: 73.0,
        total_points: 210.0,
        county: 'Lee',
        year_remeasured: 2019,
        owner: 'Michael Murray',
        nominator: 'Patrick Thompson',
        sci_lc: 'betula nigra',
        file_id: 16019.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/field/betula_nigra/1258487222_0000.jpg?raw=true',
        segmented_path:
          'dataset/segmented/field/betula_nigra/1258487222_0000.png',
        species_y: 'Betula nigra',
        source: 'field',
        wiki_summary:
          'Betula nigra, the black birch, river birch or water birch, is a species of birch native to the Eastern United States from New Hampshire west to southern Minnesota, and south to northern Florida and west to Texas. It is one of the few heat-tolerant birches in a family of mostly cold-weather trees which do not thrive in USDA Zone 6 and up. B. nigra commonly occurs in floodplains and swamps.',
        Longitude: -85.353048,
        Latitude: 32.604064,
      },
      geometry: { type: 'Point', coordinates: [-85.353048, 32.604064] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'BIRCH',
        subspecies: ' Sweet',
        scientific_name: 'Betula lenta',
        year_named: 2008.0,
        circumference_in: 53.0,
        height_in: 54.0,
        spread_ft: 31.0,
        total_points: 115.0,
        county: 'DeKalb',
        year_remeasured: 2018,
        owner: 'DeSoto State Park',
        nominator: 'Jason Shelton',
        sci_lc: 'betula lenta',
        file_id: 4375.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/field/betula_lenta/1248106459_0000.jpg?raw=true',
        segmented_path:
          'dataset/segmented/field/betula_lenta/1248106459_0000.png',
        species_y: 'Betula lenta',
        source: 'field',
        wiki_summary:
          'Betula lenta (sweet birch, also known as black birch, cherry birch, mahogany birch, or spice birch) is a species of birch native to eastern North America, from southern Maine west to southernmost Ontario, and south in the Appalachian Mountains to northern Georgia.',
        Longitude: -85.803992,
        Latitude: 34.460929,
      },
      geometry: { type: 'Point', coordinates: [-85.803992, 34.460929] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'BLACKGUM',
        subspecies: 'N/A',
        scientific_name: 'Nyssa sylvatica',
        year_named: 1988.0,
        circumference_in: 128.0,
        height_in: 108.0,
        spread_ft: 49.0,
        total_points: 248.0,
        county: 'Elmore',
        year_remeasured: 2017,
        owner: 'Joseph Collins',
        nominator: 'Jill Browning',
        sci_lc: 'nyssa sylvatica',
        file_id: 62140.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/nyssa_sylvatica/ny1128-01-1.jpg?raw=true',
        segmented_path: 'dataset/segmented/lab/nyssa_sylvatica/ny1128-01-1.png',
        species_y: 'Nyssa sylvatica',
        source: 'lab',
        wiki_summary:
          'Nyssa sylvatica, commonly known as tupelo, black tupelo, black gum or sour gum, is a medium-sized deciduous tree native to eastern North America from the coastal Northeastern United States and southern Ontario south to central Florida and eastern Texas, as well as Mexico.',
        Longitude: -86.142739,
        Latitude: 32.597229,
      },
      geometry: { type: 'Point', coordinates: [-86.142739, 32.597229] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'BUCKEYE',
        subspecies: ' Red',
        scientific_name: 'Aesculus pavia',
        year_named: 2015.0,
        circumference_in: 19.0,
        height_in: 36.0,
        spread_ft: 15.0,
        total_points: 59.0,
        county: 'Cherokee',
        year_remeasured: 2020,
        owner: 'Paul Rogers',
        nominator: 'Keith Niedermeier',
        sci_lc: 'aesculus pavia',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/aesculus_pavia/aesculus_pavia.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          "Aesculus pavia, known as red buckeye or firecracker plant, is a species of deciduous flowering plant. The small tree or shrub is native to the southern and eastern parts of the United States, found from Illinois to Virginia in the north and from Texas to Florida in the south. It is hardy far to the north of its native range, with successful cultivation poleward to Arboretum Mustila in Finland.It has a number of local names, such as scarlet buckeye, woolly buckeye and firecracker plant.\nThe red buckeye is a large shrub or small tree. It reaches a height of 16–26 feet (5–8 m), often growing in a multi-stemmed form.  Its leaves are opposite, and are composed usually of five elliptical serrated leaflets, each 4–6 inches (10–15 cm) long.  It bears 4–7-inch (10–18 cm) long clusters of attractive dark red tubular flowers in the spring. The flowers are hermaphrodite. The smooth light brown fruits, about 1 inch (2.5 cm) or so in diameter, reach maturity in early fall.\nThere are two varieties:\n\nAesculus pavia var. pavia: typical red buckeye.\nAesculus pavia var. flavescens: yellow-flowered red buckeye.The yellow-flowered variety, var. flavescens, is found in higher country in Texas, and hybrids with intermediate flower color occur.\nThe flowers are attractive to hummingbirds as well as bees. The fruits are rich in saponins, which are poisonous to humans, although not particularly dangerous because they are not ingested easily. The seeds are poisonous. The oils can be extracted to make soap, although this is not viable commercially.\nOrnamental cultivars such as the low-growing 'Humilis' have been selected for garden use.\nRed buckeye has hybridized with common horse-chestnut (Aesculus hippocastanum) in cultivation, the hybrid being named Aesculus × carnea, red horse-chestnut. The hybrid is a medium-sized tree to 45–55 feet (14–17 m) tall, intermediate between the parent species in most respects, but inheriting the red flower color from A. pavia. It is a popular tree in large gardens and parks, most commonly the selected cultivar 'Briotii'.  Hybrids of red buckeye with yellow buckeye (A. flava) have also been found, and named Aesculus × hybrida.\n\n",
        Longitude: -85.654242,
        Latitude: 34.069515,
      },
      geometry: { type: 'Point', coordinates: [-85.654242, 34.069515] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'BUCKEYE',
        subspecies: ' Yellow',
        scientific_name: 'Aesculus octandra',
        year_named: 1994.0,
        circumference_in: 98.0,
        height_in: 108.0,
        spread_ft: 39.0,
        total_points: 216.0,
        county: 'Madison',
        year_remeasured: 2021,
        owner: 'City of Huntsville',
        nominator: 'Susan Weber',
        sci_lc: 'aesculus octandra',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/aesculus_octandra/aesculus_octandra.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Aesculus flava, the yellow buckeye, common buckeye, or sweet buckeye, is a species of deciduous tree. It is native to the Ohio Valley and Appalachian Mountains of the Eastern United States. It grows in mesophytic forest or floodplains, generally in acid to circumneutral soil, reaching a height of 20m to 48m (65 ft to 154 ft).',
        Longitude: -86.55108,
        Latitude: 34.764238,
      },
      geometry: { type: 'Point', coordinates: [-86.55108, 34.764238] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'BUCKTHORN',
        subspecies: ' Carolina',
        scientific_name: 'Rhamnus caroliniana',
        year_named: 2012.0,
        circumference_in: 12.0,
        height_in: 42.0,
        spread_ft: 13.0,
        total_points: 57.0,
        county: 'Talladega',
        year_remeasured: 2017,
        owner: 'Camp Mac',
        nominator: 'John McBride',
        sci_lc: 'rhamnus caroliniana',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/rhamnus_caroliniana/rhamnus_caroliniana.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Frangula caroliniana, commonly called the  Carolina buckthorn, is a deciduous upright shrub or small tree native to the southeastern, south-central, and mid-western parts of the United States, from Texas east to Florida and north as far as Maryland, Ohio, Missouri, and Oklahoma. There is also an isolated population in the State of Nuevo León in northeastern Mexico. It is found in a wide variety of habitats, including barrens, forests, and limestone bluffs.\n\n',
        Longitude: -86.175805,
        Latitude: 33.369277,
      },
      geometry: { type: 'Point', coordinates: [-86.175805, 33.369277] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'BUMELIA',
        subspecies: ' Buckthorn',
        scientific_name: 'Sideroxylon lycioides',
        year_named: 2011.0,
        circumference_in: 21.0,
        height_in: 31.0,
        spread_ft: 28.0,
        total_points: 59.0,
        county: 'Lauderdale',
        year_remeasured: 2021,
        owner: 'Joe Wheeler State Park',
        nominator: 'Jason Shelton',
        sci_lc: 'bumelia lycioides',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/sideroxylon_lycioides/sideroxylon_lycioides.jpg?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          "Sideroxylon lycioides, the buckthorn bully, is a small tree in the family Sapotaceae. It is widely distributed in the southeastern United States from Texas to southeast Virginia.The fruit pulp is thin but edible and consumed by birds. Livestock browse the plant's foliage.",
        Longitude: -87.650997,
        Latitude: 34.904122,
      },
      geometry: { type: 'Point', coordinates: [-87.650997, 34.904122] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'BUMELIA',
        subspecies: ' Gum',
        scientific_name: 'Bumelia lanuginosa',
        year_named: 1994.0,
        circumference_in: 51.0,
        height_in: 45.0,
        spread_ft: 34.0,
        total_points: 105.0,
        county: 'Blount',
        year_remeasured: 2017,
        owner: 'Marvin & Barbara Whited',
        nominator: 'Bob G. Winters',
        sci_lc: 'bumelia lanuginosa',
        file_id: null,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/wiki/bumelia_lanuginosa/bumelia_lanuginosa.gif?raw=true',
        segmented_path: null,
        species_y: null,
        source: null,
        wiki_summary:
          'Sideroxylon lanuginosum is a shrub or small tree of the family Sapotaceae. It is native to the Sun Belt and Midwest of the United States as well as Northeastern Mexico. Common names include gum bully, black haw, chittamwood, chittimwood, shittamwood, false buckthorn, gum bumelia, gum elastic, gum woolybucket, woolybucket bumelia, wooly buckthorn, wooly bumelia, ironwood and coma.\nThe fruit of Bumelia lanuginosa is edible but can cause stomach aches or dizziness if eaten in large quantities. The Kiowa and Comanche tribes both consumed them when ripened. Gum from the trunk of the tree is sometimes chewed by children.',
        Longitude: -86.567246,
        Latitude: 33.977448,
      },
      geometry: { type: 'Point', coordinates: [-86.567246, 33.977448] },
    },
    {
      type: 'Feature',
      properties: {
        species_x: 'BUTTERNUT',
        subspecies: 'N/A',
        scientific_name: 'Juglans cinerea',
        year_named: 2011.0,
        circumference_in: 111.0,
        height_in: 63.0,
        spread_ft: 71.0,
        total_points: 192.0,
        county: 'Jackson',
        year_remeasured: 2021,
        owner: 'Daryl & Donna Lawson',
        nominator: 'Jason Shelton',
        sci_lc: 'juglans cinerea',
        file_id: 58738.0,
        image_path:
          'https://github.com/iceicery/trick-or-tree/blob/main/dataset/images/lab/juglans_cinerea/wb1487-01-1.jpg?raw=true',
        segmented_path: 'dataset/segmented/lab/juglans_cinerea/wb1487-01-1.png',
        species_y: 'Juglans cinerea',
        source: 'lab',
        wiki_summary:
          'Juglans cinerea, commonly known as butternut or white walnut, is a species of walnut native to the eastern United States and southeast Canada.\n\n',
        Longitude: -85.9774,
        Latitude: 34.763522,
      },
      geometry: { type: 'Point', coordinates: [-85.9774, 34.763522] },
    },
  ],
};
